import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import "./banner.scss";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../header/Navbar";
import Modal from "react-bootstrap/Modal";
import EthPrice from "../../../hooks/chinaFunction/ethPrice";
import useTokenPrice from "../../../hooks/chinaFunction/tokenPrice";
import useGemsPrice from "../../../hooks/dataFetchers/useGemsPrice";
import usePaymentPriceRefresh from "../../../hooks/dataFetchers/usePaymentPriceRefresh";
import UniPrice from "../../../hooks/chinaFunction/uniPrice";
import LinkPrice from "../../../hooks/chinaFunction/linkPrice";
import { useWeb3React } from "../../../hooks/useWagmiCompat";
import useWeb3 from "../../../hooks/useWeb3";
import moment from "moment";
import AllowanceTpl from "../../../hooks/dataFetchers/AllowanceTpl";
import AllowanceTpl1 from "../../../hooks/dataFetchers/AllowanceTpl1";
import ApproveTpl from "../../../hooks/dataFetchers/ApproveTpl";
import ApproveTplUsdc from "../../../hooks/dataFetchers/ApproveTplUsdc";
import ApproveTplUsdc1 from "../../../hooks/dataFetchers/approveTplUsdc1";
import ApproveTplWbtc from "../../../hooks/dataFetchers/ApproveTplWbtc";
import ApproveTplWbtc1 from "../../../hooks/dataFetchers/approveTplWbtc1";
import ApproveTomi from "../../../hooks/dataFetchers/ApproveTomi";
import ApproveGems from "../../../hooks/dataFetchers/ApproveGems";
import ApproveLink from "../../../hooks/dataFetchers/ApproveLink";
import ApprovePepe from "../../../hooks/dataFetchers/ApprovePepe";
import ApproveUnisawape from "../../../hooks/dataFetchers/ApproveUniswape";
import ApproveTomi1 from "../../../hooks/dataFetchers/ApproveTomi1";
import ApproveTpl1 from "../../../hooks/dataFetchers/ApproveTpl1";
import BalacefAccount from "../../../hooks/dataFetchers/BalaceOfAccount";
import PurchaseEth from "../../../hooks/chinaFunction/purchaseEth";
import PurchaseEth1 from "../../../hooks/chinaFunction/purchaseEth1";
import PurchaseUsdt from "../../../hooks/chinaFunction/purchaseUsdt";
import PurchaseUsdc from "../../../hooks/chinaFunction/purchaseUsdc";
import PurchaseUsdc1 from "../../../hooks/chinaFunction/purchaseUsdc1";
import PurchaseWbtc from "../../../hooks/chinaFunction/purchaseWbtc";
import PurchaseWbtc1 from "../../../hooks/chinaFunction/purchaseWbtc1";
import PurchaseUsdt1 from "../../../hooks/chinaFunction/purchaseUsdt1";
import PurchasePepe from "../../../hooks/chinaFunction/purchasePepe";
import PurchaseLink from "../../../hooks/chinaFunction/purchaseLink";
import PurchaseUniswape from "../../../hooks/chinaFunction/purchaseUniswape";
import Loader from "../../../hooks/loader";
import axios from "axios";
import { API_URL } from "../../../utils/ApiUrl";
import { toast } from "react-toastify";
import CuurentRound from "../../../hooks/chinaFunction/round";
import CuurentRoundNft from "../../../hooks/chinaFunction/roundNft";
import SaleStatus from "../../../hooks/chinaFunction/saleStatus";
import SaleStatusNft from "../../../hooks/chinaFunction/saleStatusNft";
import PsMarketCap from "../../../hooks/chinaFunction/psMarketCap";
import InMarketCap from "../../../hooks/chinaFunction/inMarketCap";
import SaleStatus1 from "../../../hooks/chinaFunction/saleStatus1";
import InTotalPurchase from "../../../hooks/chinaFunction/inTotalPurchase";
import PsTotalPurchase from "../../../hooks/chinaFunction/psTotalPurchase";
import Timer from "../../../hooks/chinaFunction/timer";
import TimerNft from "../../../hooks/chinaFunction/timeNft";
import { useHistory } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DopNft from "../../DopNft/DopNft";
import BalacefAccountTomi from "../../../hooks/dataFetchers/BlanaceOfAccountTom";
import BalacefAccountGems from "../../../hooks/dataFetchers/BlanaceOfAccountGems";
import BalacefAccountLink from "../../../hooks/dataFetchers/BalacefAccountLink";
import BalacefAccountPepe from "../../../hooks/dataFetchers/BalacefAccountPepe";
import BalacefAccountUni from "../../../hooks/dataFetchers/BalacefAccountUni";
import BalacefAccountUsdc from "../../../hooks/dataFetchers/BalanceOfAccountUsdc";
import BalacefAccountWbtc from "../../../hooks/dataFetchers/BalanceOfAccountWbtc";
import AllowanceTomi from "../../../hooks/dataFetchers/AllowanceTomi";
import AllowanceGems from "../../../hooks/dataFetchers/AllowanceGems";
import AllowanceLink from "../../../hooks/dataFetchers/AllowanceLink";
import AllowancePepe from "../../../hooks/dataFetchers/AllowancePepe";
import AllowanceUniswape from "../../../hooks/dataFetchers/AllowanceUniswape";
import AllowanceUsdc from "../../../hooks/dataFetchers/AllowanceUsdc";
import AllowanceUsdc1 from "../../../hooks/dataFetchers/AllowanceUsdc1";
import AllowanceWbtc from "../../../hooks/dataFetchers/AllowanceWbtc";
import AllowanceWbtc1 from "../../../hooks/dataFetchers/AllowanceWbtc1";
import AllowanceTomi1 from "../../../hooks/dataFetchers/AllowanceTomi1";
import PurchaseTomi from "../../../hooks/chinaFunction/purchaseTomi";
import PurchaseTomi1 from "../../../hooks/chinaFunction/puchaseTomi1";
import DiscountedPrice from "../../../hooks/chinaFunction/discountedPrice";
import Environment from "../../../utils/Environment";
import { enrichRoundWithKind } from "../../../utils/roundKind";
import {
  getPresaleRealtimeValidation,
  getStablecoinMinOrderAdjustment,
  stablecoinPayToUsd,
  qualifiesForRegularBulkDiscount,
  getRegularBulkDiscountedPrice,
  getPurchasePriceForApi,
  fmtUsd,
  fmtCredits,
  getKaiCreditsUnlockedBySpecialPurchase,
} from "../../../utils/presaleRoundLimits";
import {
  normalizeDecimalString,
  formatDisplayUsd,
  formatDisplayPrice,
  formatDisplayTokenAmount,
  formatDisplayPaymentAmount,
  formatDisplayNumber,
} from "../../../utils/formatDisplay";
import usePresaleRoundLimits from "../../../hooks/dataFetchers/usePresaleRoundLimits";
import {
  persistSpecialUserFlag,
  readSpecialUserFlag,
} from "../../../utils/specialUser";
import useCreditBalance from "../../../hooks/dataFetchers/useCreditBalance";
import WbtcPrice from "../../../hooks/chinaFunction/wbtcPrice";
import AllowanceDop from "../../../hooks/dataFetchers/AllowanceDop";
import ApproveDop from "../../../hooks/dataFetchers/ApproveDop";
import PurchaseDop from "../../../hooks/chinaFunction/purchaseDop";
import AllowanceDop1 from "../../../hooks/dataFetchers/AllowanceDop1";
import ApproveDop1 from "../../../hooks/dataFetchers/ApproveDop1";
import PurchaseDop1 from "../../../hooks/chinaFunction/purchaseDop1";
import BalacefAccountDop from "../../../hooks/dataFetchers/balanceOfAccountDop";
import { setupNetwork } from "../../../utils/wallet";
import GetGemsStakedIndex from "../../../hooks/chinaFunction/getGemsStakedIndex";
import GetGemsStaked from "../../../hooks/chinaFunction/getGemsStakeAmount";
import { storeReferrer } from "@sharemint/sdk";
import PurchaseGems from "../../../hooks/chinaFunction/purchaseGems";
import PurchaseGems1 from "../../../hooks/chinaFunction/purchaseGems1";
import AllowanceGems1 from "../../../hooks/dataFetchers/AllowanceGems1";
import ApproveGems1 from "../../../hooks/dataFetchers/ApproveGems1";
import InsurancePercentage from "../../../hooks/dataFetchers/insurancePercentage";
import useRecordEvent from "../../../hooks/useRecordEvent";
import RoundTimer from "./RoundTimer";
import useWeb3ErrorToast, {
  generateToast,
} from "../../../utils/useWeb3ErrorToast";
import Footer from "../Footer/Footer";
import TermsOfServiceModal from "./TermsOfServiceModal";
import useAuth from "../../../hooks/useAuth";
import {
  clearWalletSession,
  setWalletSession,
} from "../../../utils/walletSession";
import { requestWithState } from "../../../@api/requestWithState";
import { notifyInfo } from "../../Toast";
import { getGemsTokenContract } from "../../../utils/contractHelpers";

/** Gems Premium + staked-holder discount UI/API paths. Set `true` to restore for the client. */
const PREMIUM_STAKING_FLOW_ENABLED = false;

const CHAIN = process.env.REACT_APP_CHAIN_ID;

const Banner = ({ setShow }) => {
  // let sharemintValue = localStorage.getItem("sharemint");
  let ipBuyer = localStorage.getItem("ip");
  let countryBuyer = localStorage.getItem("country");
  const Presale = Environment?.presale;
  const { login, logout } = useAuth();
  const { recordEvent } = useRecordEvent();
  const { handleError } = useWeb3ErrorToast();
  const [checkBoxx, setCheckBoxx] = useState(false);
  const [insurancePer, setInsurancePer] = useState(0);
  // const { allowanceDop } = AllowanceDop();
  // const { allowanceDop1 } = AllowanceDop1();
  const { approveDop } = ApproveDop();
  const { approveDop1 } = ApproveDop1();
  const { purchaseDop } = PurchaseDop();
  const { purchaseDop1 } = PurchaseDop1();
  // const { balacefAccountDop } = BalacefAccountDop();
  const history = useHistory();
  const { getGemsStaked } = GetGemsStaked();
  // const { getGemsStakedIndex } = GetGemsStakedIndex();
  // const { allowanceLink } = AllowanceLink();
  // const { allowanceTomi } = AllowanceTomi();
  const { allowanceGems } = AllowanceGems();
  // const { allowancePepe } = AllowancePepe();
  // const { allowanceUniswape } = AllowanceUniswape();
  const { allowanceUsdc } = AllowanceUsdc();
  // const { allowanceWbtc } = AllowanceWbtc();
  // const { allowanceUsdc1 } = AllowanceUsdc1();
  // const { allowanceWbtc1 } = AllowanceWbtc1();
  // const { allowanceTomi1 } = AllowanceTomi1();
  const { cuurentRound } = CuurentRound();
  // const { cuurentRoundNft } = CuurentRoundNft();
  const { saleStatus } = SaleStatus();
  // const { saleStatusNft } = SaleStatusNft();
  // const { insurancePercentage } = InsurancePercentage();
  // const { psMarketCap } = PsMarketCap();
  // const { inMarketCap } = InMarketCap();
  // const { psTotalPurchase } = PsTotalPurchase();
  // const { inTotalPurchase } = InTotalPurchase();
  // const { saleStatus1 } = SaleStatus1();
  const { timer } = Timer();
  const { timerNft } = TimerNft();
  const { purchaseTomi } = PurchaseTomi();
  const { purchaseGems } = PurchaseGems();
  const { approveGems1 } = ApproveGems1();
  const { purchaseGems1 } = PurchaseGems1();
  // const { allowanceGems1 } = AllowanceGems1();
  const [gemsAllowance1, setGemsAllwance1] = useState(null);
  const { purchaseTomi1 } = PurchaseTomi1();
  const { discountedPrice } = DiscountedPrice();
  const [psTotlaPurchasess, setPsTotlaPurchasess] = useState(null);
  const [inTotlaPurchasess, setInTotlaPurchasess] = useState(null);
  const [psmyTotlaPurchasess, setMyPsTotlaPurchasess] = useState(null);
  const [inMyTotlaPurchasess, setMyInTotlaPurchasess] = useState(null);
  const [psMaxxCap, setPsMaxxCap] = useState(null);
  // const [inMaxxCap, setInMaxxCap] = useState(null);
  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakingData, setStakingData] = useState([]);
  var now11 = new Date();
  let createdDate = now11?.getTime();

  useEffect(() => {
    storeReferrer();
    return () => { };
  }, []);
  // console.log(createdDate,'createdDate');
  // const capHandler = async () => {
  //   try {

  //     // const { psMarketCap } = PsMarketCap()
  //     // const { inMarketCap } = InMarketCap()
  //     // const { psTotalPurchase } = PsTotalPurchase()
  //     // const { inTotalPurchase } = InTotalPurchase()
  //     let a = await psMarketCap()
  //     setPsMaxxCap(a)
  //     let b = await inMarketCap()
  //     setInMaxxCap(b)
  //     let c = await psTotalPurchase()
  //     setPsTotlaPurchasess(c)
  //     let v = await inTotalPurchase()
  //     setInTotlaPurchasess(v)
  //     // console.log(a,b,v,c,'total cap');
  //   } catch (err) {
  //     console.log(err, 'err from cap');

  //   }
  // }

  // // console.log(psMaxxCap,psmyTotlaPurchasess,'nooooooooor',psTotlaPurchasess);
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  const objjjj = localStorage?.getItem("oobjj");
  const code = localStorage?.getItem("accessCode");
  const role = localStorage?.getItem("role_ins");
  const modalTwitter = localStorage?.getItem("twittter");
  const startTime11 = localStorage?.getItem("timeeee");
  const [id, setId] = useState(null);
  const [price, setPrice] = useState(null);
  const [round, setRound] = useState(null);
  const [loaderr, setLoarder] = useState(false);
  const [loaderr1, setLoarder1] = useState(false);
  const { purchaseUsdt } = PurchaseUsdt();
  const { purchaseUsdc } = PurchaseUsdc();
  const { purchaseUsdc1 } = PurchaseUsdc1();
  const { purchaseWbtc } = PurchaseWbtc();
  const { purchaseWbtc1 } = PurchaseWbtc1();
  const { purchasePepe } = PurchasePepe();
  const { purchaseLink } = PurchaseLink();
  const { purchaseUniswape } = PurchaseUniswape();
  const { purchaseEth } = PurchaseEth();
  const { purchaseUsdt1 } = PurchaseUsdt1();
  const { purchaseEth1 } = PurchaseEth1();
  const { approveTpl } = ApproveTpl();
  const { approveTplUsdc } = ApproveTplUsdc();
  const { approveTplwbtc } = ApproveTplWbtc();
  const { approveTplUsdc1 } = ApproveTplUsdc1();
  const { approveTplwbtc1 } = ApproveTplWbtc1();
  const { approveTomi } = ApproveTomi();
  const { approveGems } = ApproveGems();
  const { approveLink } = ApproveLink();
  const { approvePepe } = ApprovePepe();
  const { approveUnisawape } = ApproveUnisawape();
  const { approveTomi1 } = ApproveTomi1();
  const { approveTpl1 } = ApproveTpl1();
  const { allowanceTpl } = AllowanceTpl();
  const { allowanceTpl1 } = AllowanceTpl1();
  const { balacefAccount } = BalacefAccount();
  const { balacefAccountTomi } = BalacefAccountTomi();
  const { balacefAccountGems } = BalacefAccountGems();
  const { balacefAccountLink } = BalacefAccountLink();
  const { balacefAccountUni } = BalacefAccountUni();
  const { balacefAccountPepe } = BalacefAccountPepe();
  const { balacefAccountUsdc } = BalacefAccountUsdc();
  const { balacefAccountWbtc } = BalacefAccountWbtc();
  const [currentRoundd, setCurrentRoundd] = useState(null);
  const [copyOfPrice, setCopyOfPrice] = useState(null);
  const [priceCheck, setPriceCheck] = useState(false);
  const web3 = useWeb3();
  let now = Date.now();
  const { ethPrice } = EthPrice();
  const { getTokenPriceUsd } = useTokenPrice();
  // const { linkPrice } = LinkPrice();
  // const { uniPrice } = UniPrice();
  // const { wbtcPrice } = WbtcPrice();
  const [inputFeild, setInputField] = useState(null);
  /** Raw payment input shown in the field when stablecoin min-order adjustment applies. */
  const [userPayInput, setUserPayInput] = useState(null);
  const [inputFeild1, setInputField1] = useState(null);
  const [ethPricevalue, setEthPrice] = useState(0);
  const [usdtPriceUsd, setUsdtPriceUsd] = useState(1);
  const [usdcPriceUsd, setUsdcPriceUsd] = useState(1);
  const [uniPricevalue, setUniPrice] = useState(0);
  const [dopPricevalue, setDopPrice] = useState(0);
  const [linkPricevalue, setlinkPrice] = useState(0);
  const [blanceOfEth, setBlanceOfEth] = useState(0);
  const [date, setDate] = useState(0);
  const [mainTag, setMainTag] = useState("ETH");
  const [mainTag1, setMainTag1] = useState("USDT");
  const { account, chainId } = useWeb3React();
  const [balanceeUsdt, setBalanceeUsdt] = useState(null);
  const [sallowance, setAllowance] = useState(null);
  const [getAllowanceUsdc, setAllowanceUsdc] = useState(null);
  const [getAllowanceWbtc, setAllowanceWbtc] = useState(null);
  const [getAllowanceUsdc1, setAllowanceUsdc1] = useState(null);
  const [getAllowanceWbtc1, setAllowanceWbtc1] = useState(null);
  const [sallowance1, setAllowance1] = useState(null);
  const [currentRount, setCurrentRount] = useState(null);
  const [selectedRoundKind, setSelectedRoundKind] = useState(
    () => localStorage.getItem("selectedRoundKind") || "regular",
  );
  const [currentTimer, setCurrentTimer] = useState(null);
  const [timeshow, setTimeshow] = useState(false);

  const [saleCurrentStaus, setSaleCurrentStaus] = useState(false);
  const [saleCurrentStaus1, setSaleCurrentStaus1] = useState(false);
  const [amountInUsdt, setAmountInUsdt] = useState(null);
  const [isSpecialUser, setIsSpecialUser] = useState(() =>
    readSpecialUserFlag(),
  );
  const [niceName, setNicName] = useState(null);
  // console.log(niceName,'niceName');
  const [tab, setTab] = useState("home");
  const [tagImge, setTagImge] = useState("/assets/eth-icon.svg");
  const [pepePrice, setPepePrice] = useState(0);
  const [tomiPrice, setTomiPrice] = useState(0);
  const { gemsPriceUsd: gemsPrice, refetchGemsPrice } = useGemsPrice();
  const [gemsBalance, setGemsBalance] = useState(0);
  const [wbtcCurrentPrice, setWbtcCurrentPrice] = useState(null);
  // const [usdcCurrentPrice,setUsdcCurrentPrice]=useState(null)
  const [balaceOfTmi, setBalanceOfTomi] = useState(null);
  const [balaceOfUnii, setBalanceOfUnii] = useState(null);
  const [balaceOfDoppp, setBalanceOfDopp] = useState(null);
  const [balaceOfLinkk, setBalanceOfLinkk] = useState(null);
  const [balaceOfPepee, setBalanceOfPepee] = useState(null);
  const [balaceOfUsdc, setBalanceOfUsdc] = useState(null);
  const [balaceOfWbtc, setBalanceOfWbtc] = useState(null);
  const [tomiAllowance, setTomiAllwance] = useState(null);
  const [gemsAllowance, setGemsAllwance] = useState(null);
  const [uniAllowance, setUniAllwance] = useState(null);
  const [linkAllowance, setLinkAllwance] = useState(null);
  const [dopAllowance, setDopAllwance] = useState(null);
  const [dopAllowance1, setDopAllwance1] = useState(null);
  const [pepeAllowance, setPepeAllwance] = useState(null);
  const [tomiAllowance1, setTomiAllwance1] = useState(null);
  const [percent, setPercet] = useState(0);
  const [stakeIndex, setStakeIndux] = useState([]);
  const [stakedAmount, setStakedAmount] = useState(0);
  const [multiplyPercentNumbere, setMultiplyPercentNumbere] = useState(0);
  const [discountedPriceee, setDiscountedPriceee] = useState(0);
  const [ethValueCalcualte, setethValueCalcualte] = useState(null);
  const [stakeEndTime1, setStakeEndTime1] = useState([]);
  const [stakingData1, setStakingData1] = useState({});
  const [allowedTokens, setAllowedTokens] = useState([]);

  const hasPremiumStakingPerks =
    PREMIUM_STAKING_FLOW_ENABLED &&
    ((stakedAmount >= 5555 && stakingData?.length > 0) ||
      moment().isBefore(stakeEndTime1));

  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isNewMailRequired, setIsNewMailRequired] = useState(false);
  const [email, setEmail] = useState(null);
  const [isValidMail, setIsValidMail] = useState(true);
  const [isMailVerificationChecked, setIsMailVerificationChecked] =
    useState(false);
  const [otpRequired, setOtpRequired] = useState(false);

  const [otp, setOtp] = useState("");
  const [isCodeValid, setIsCodeValid] = useState(true);
  const [codeSentOnce, setCodeSentOnce] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  const [readDisclaimer, setReadDisclaimer] = useState(false);
  const [checkDisclaimer, setCheckDisclaimer] = useState(false);
  const [checkPurchaseDisclaimer, setCheckPurchaseDisclaimer] = useState(false);
  const [checkCitizenship, setCheckCitizenship] = useState(false);
  const [checkMerketing, setCheckMerketing] = useState(true);

  const [showtermsservices, setShowTermsServices] = useState(false);
  const [attemptedDisclaimer, setAttemptedDisclaimer] = useState(false);

  const handleCloseTermsServices = () => {
    setShowTermsServices(false);
  };

  const handleShowTermsServices = () => {
    setReadDisclaimer(true);
    setShowTermsServices(true);
  };

  const handleDisclaimerCheckbox = () => {
    if (!readDisclaimer) {
      setAttemptedDisclaimer(true);
      return;
    }
    setCheckDisclaimer(true);
  };

  const canBuy =
    checkDisclaimer && checkPurchaseDisclaimer && checkCitizenship;

  const {
    gemsSpentUsd,
    specialSpentUsd,
    regularInvestedUsd,
    gemsRoundCapWei,
    totalGemsRoundSoldWei,
    gemsRoundUsdCap,
    specialRoundUsdCap,
    regularInvestedThresholdUsd,
    regularMinOrderUsd,
    regularBulkDiscountRate,
    regularBulkDiscountPercent,
    refetchPresaleLimits,
  } = usePresaleRoundLimits(account);

  const isSpecialRound = selectedRoundKind === "special";
  const { remainingCreditUsd, refetchCreditBalance } = useCreditBalance(
    account,
    isSpecialRound,
  );

  const paymentTokenUsdPrice = useMemo(() => {
    switch (mainTag) {
      case "ETH":
        return Number(ethPricevalue) || 0;
      case "USDT":
        return Number(usdtPriceUsd) || 0;
      case "USDC":
        return Number(usdcPriceUsd) || 0;
      case "GEMS":
        return Number(gemsPrice) || 0;
      default:
        return 0;
    }
  }, [mainTag, ethPricevalue, usdtPriceUsd, usdcPriceUsd, gemsPrice]);

  const stablecoinMinAdjustment = useMemo(
    () =>
      getStablecoinMinOrderAdjustment({
        roundKind: selectedRoundKind,
        paymentToken: mainTag,
        paymentTokenUsdPrice,
        enteredPayCrypto: userPayInput ?? inputFeild,
        regularInvestedUsd,
        regularInvestedThresholdUsd,
        regularMinOrderUsd,
      }),
    [
      selectedRoundKind,
      mainTag,
      paymentTokenUsdPrice,
      userPayInput,
      inputFeild,
      regularInvestedUsd,
      regularInvestedThresholdUsd,
      regularMinOrderUsd,
    ],
  );

  const activePayInputRaw = useMemo(() => {
    if (userPayInput !== null && userPayInput !== undefined && userPayInput !== "") {
      return userPayInput;
    }
    return inputFeild;
  }, [userPayInput, inputFeild]);

  const { refreshActivePaymentPrice } = usePaymentPriceRefresh({
    mainTag,
    account,
    payInputRaw: activePayInputRaw,
    ethPrice,
    getTokenPriceUsd,
    refetchGemsPrice,
    setEthPrice,
    setUsdtPriceUsd,
    setUsdcPriceUsd,
  });

  const activePayCrypto = useMemo(() => {
    const raw = activePayInputRaw;
    if (raw === "" || raw == null) return 0;
    return Math.max(0, parseFloat(raw) || 0);
  }, [activePayInputRaw]);

  const effectivePayCrypto = useMemo(() => {
    if (activePayCrypto <= 0) return 0;
    if (stablecoinMinAdjustment) {
      return stablecoinMinAdjustment.adjustedPayCrypto;
    }
    return Math.max(0, parseFloat(inputFeild) || 0);
  }, [stablecoinMinAdjustment, inputFeild, activePayCrypto]);

  const effectiveAmountInUsdt = useMemo(() => {
    if (activePayCrypto <= 0) return 0;
    if (stablecoinMinAdjustment) {
      return stablecoinMinAdjustment.targetUsd;
    }
    if (mainTag === "USDT" || mainTag === "USDC") {
      if (paymentTokenUsdPrice > 0) {
        return stablecoinPayToUsd(activePayCrypto, paymentTokenUsdPrice);
      }
    }
    return Math.max(0, Number(amountInUsdt) || 0);
  }, [
    stablecoinMinAdjustment,
    amountInUsdt,
    mainTag,
    activePayCrypto,
    paymentTokenUsdPrice,
  ]);

  const paymentInputUsdDisplay = useMemo(() => {
    if (activePayCrypto <= 0) return 0;
    if (stablecoinMinAdjustment) {
      return stablecoinMinAdjustment.enteredUsd;
    }
    if (mainTag === "USDT" || mainTag === "USDC") {
      if (paymentTokenUsdPrice > 0) {
        return stablecoinPayToUsd(activePayCrypto, paymentTokenUsdPrice);
      }
    }
    return Math.max(0, Number(amountInUsdt) || 0);
  }, [
    stablecoinMinAdjustment,
    amountInUsdt,
    mainTag,
    activePayCrypto,
    paymentTokenUsdPrice,
  ]);

  const payInputDisplayValue = activePayInputRaw ?? "";

  const purchasePriceForApi = useMemo(
    () =>
      getPurchasePriceForApi({
        basePriceUsd: price,
        discountedStakingPriceUsd: discountedPriceee,
        roundKind: selectedRoundKind,
        amountInUsdt: effectiveAmountInUsdt,
        hasPremiumStakingPerks,
        regularMinOrderUsd,
        regularBulkDiscountRate,
      }),
    [
      price,
      discountedPriceee,
      selectedRoundKind,
      effectiveAmountInUsdt,
      hasPremiumStakingPerks,
      regularMinOrderUsd,
      regularBulkDiscountRate,
    ],
  );

  const showBulkPurchaseSummary = useMemo(() => {
    if (hasPremiumStakingPerks) return false;
    const paidUsd = effectiveAmountInUsdt;
    if (paidUsd <= 0) return false;
    return qualifiesForRegularBulkDiscount(
      selectedRoundKind,
      paidUsd,
      regularMinOrderUsd,
    );
  }, [
    hasPremiumStakingPerks,
    selectedRoundKind,
    effectiveAmountInUsdt,
    regularMinOrderUsd,
  ]);

  const bulkPurchaseSummary = useMemo(() => {
    if (!showBulkPurchaseSummary) return null;
    const paidUsd = effectiveAmountInUsdt;
    const payCrypto = effectivePayCrypto;
    const rate = regularBulkDiscountRate;
    const originalUsd = rate > 0 && rate < 1 ? paidUsd / (1 - rate) : paidUsd;
    const discountUsd = originalUsd - paidUsd;
    const originalPayCrypto =
      payCrypto > 0 && rate > 0 && rate < 1 ? payCrypto / (1 - rate) : 0;
    return { paidUsd, originalUsd, discountUsd, originalPayCrypto, payCrypto };
  }, [
    showBulkPurchaseSummary,
    effectiveAmountInUsdt,
    effectivePayCrypto,
    regularBulkDiscountRate,
  ]);

  const paymentBalance = useMemo(() => {
    const n = (v) => Math.max(0, Number(v) || 0);
    switch (mainTag) {
      case "ETH":
        return n(blanceOfEth);
      case "USDT":
        return n(balanceeUsdt);
      case "USDC":
        return n(balaceOfUsdc);
      case "WBTC":
        return n(balaceOfWbtc);
      case "LINK":
        return n(balaceOfLinkk);
      case "PEPE":
        return n(balaceOfPepee);
      case "UNI":
        return n(balaceOfUnii);
      case "DOP":
        return n(balaceOfDoppp);
      case "TOMI":
        return n(balaceOfTmi);
      case "GEMS":
        return n(gemsBalance);
      default:
        return n(gemsBalance);
    }
  }, [
    mainTag,
    blanceOfEth,
    balanceeUsdt,
    balaceOfUsdc,
    balaceOfWbtc,
    balaceOfLinkk,
    balaceOfPepee,
    balaceOfUnii,
    balaceOfDoppp,
    balaceOfTmi,
    gemsBalance,
  ]);

  const saleValidation = useMemo(
    () =>
      getPresaleRealtimeValidation({
        roundKind: selectedRoundKind,
        mainTag,
        amountInUsdt: effectiveAmountInUsdt,
        gemsSpentUsd,
        specialSpentUsd,
        regularInvestedUsd,
        isSpecialUser,
        gemsRoundUsdCap,
        specialRoundUsdCap,
        regularInvestedThresholdUsd,
        regularMinOrderUsd,
        regularBulkDiscountPercent,
        remainingCreditUsd,
        paymentTokenBalance: paymentBalance,
        payAmountRaw:
          effectivePayCrypto > 0
            ? String(effectivePayCrypto)
            : inputFeild ?? "",
        insuranceChecked: checkBoxx,
        insurancePer,
        gemsRoundCapWei,
        totalGemsRoundSoldWei,
        kaiReceiveAmount: parseFloat(inputFeild1) || 0,
        saleTokenSymbol: Presale?.symbol || "KAI",
        kaiPriceUsd: price ?? 0,
      }),
    [
      selectedRoundKind,
      mainTag,
      effectiveAmountInUsdt,
      effectivePayCrypto,
      gemsSpentUsd,
      specialSpentUsd,
      regularInvestedUsd,
      isSpecialUser,
      gemsRoundUsdCap,
      specialRoundUsdCap,
      regularInvestedThresholdUsd,
      regularMinOrderUsd,
      regularBulkDiscountPercent,
      remainingCreditUsd,
      paymentBalance,
      inputFeild,
      checkBoxx,
      insurancePer,
      gemsRoundCapWei,
      totalGemsRoundSoldWei,
      inputFeild1,
      Presale?.symbol,
      price,
    ],
  );

  const roundLimitErrorMessage = saleValidation.error;
  const roundLimitHintMessage = saleValidation.hint;
  const canBuyWithRoundLimits = canBuy && saleValidation.ok;

  const resetPaymentInputs = () => {
    setInputField("");
    setUserPayInput("");
    setInputField1("");
    setAmountInUsdt(0);
    setethValueCalcualte(0);
    setMyInTotlaPurchasess(0);
    setMyPsTotlaPurchasess(0);
  };

  const prevSelectedRoundKindRef = useRef(null);
  useEffect(() => {
    const prevKind = prevSelectedRoundKindRef.current;
    if (selectedRoundKind === "gems") {
      setMainTag("GEMS");
      setTagImge("/assets/newgemslogosvg.svg");
      if (prevKind !== "gems") resetPaymentInputs();
    } else if (prevKind === "gems") {
      setMainTag("ETH");
      setTagImge("/assets/eth-icon.svg");
      resetPaymentInputs();
    } else if (prevKind != null && prevKind !== selectedRoundKind) {
      resetPaymentInputs();
    }
    prevSelectedRoundKindRef.current = selectedRoundKind;
  }, [selectedRoundKind]);

  const [modalDelay, setModalDelay] = useState(true);

  setTimeout(() => {
    setModalDelay(false);
  }, 2000);

  const [isVerificationDone, setIsVerificationDone] = useState(true);

  const handleCloseVerification = () => setIsVerificationDone(true);
  const handleShowVerification = () => setIsVerificationDone(false);

  useEffect(() => {
    if (modalDelay) return;
    const data = localStorage.getItem("verifiedData");
    const verifiedData = data ? JSON.parse(data) : null;

    const isVerified =
      !!account &&
      verifiedData?.address.toLowerCase() === account.toLowerCase() &&
      verifiedData?.email;

    if (!account) {
      handleShowVerification();
      return;
    }

    if (isVerified) {
      handleCloseVerification();
      setEmail(verifiedData.email);
      getUserMongoId();
      return;
    }

    handleShowVerification();
    checkGeneralVerification();
    getUserMongoId();
  }, [account, modalDelay]);

  const getUserMongoId = async () => {
    if (!account) return;
    const normalizedAccount = account.toLowerCase();
    const stored = localStorage.getItem("walletMongoId");
    const cached = stored ? JSON.parse(stored) : null;

    if (cached?.mongoId && cached?.address === normalizedAccount) {
      return;
    }

    try {
      const res = await axios.get(`${API_URL}wallet/${normalizedAccount}/get`);

      const mongoId = res?.data?.data?._id;
      if (!mongoId) return;

      localStorage.setItem(
        "walletMongoId",
        JSON.stringify({
          mongoId,
          address: normalizedAccount,
        }),
      );
    } catch (error) {
      console.error("Error fetching mongoId:", error);
    }
  };

  const checkGeneralVerification = async () => {
    if (!account) return;
    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/wallet-details`,
        method: "POST",
        data: {
          by: account.toLowerCase(),
        },
      });
      setLoarder1(false);
      // console.log(response?.deta, "Verification Response");
      const data = response?.deta;
      if (data?.isVerified) {
        setIsEmailVerified(true);
        // console.log("Verified fetched successfully:", response?.data);
        setEmail(data?.email || null);
        await callRecordEventAgreement(data?.email, true, true);
      } else {
        setIsEmailVerified(false);
        setEmail(data?.email || null);
        setIsNewMailRequired(true);
        // await callRecordEventAgreement(data?.email);
        console.log("User is not verified");
      }
    } catch (error) {
      setIsEmailVerified(false);
      setEmail(null);
      console.error("Error checking verified:", error);
    } finally {
      setLoarder1(false);
    }
  };

  const handlCheckEmailVerification = async () => {
    if (!isValidEmail(email)) {
      setIsValidMail(false);
      return;
    }

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/email-details?email=${email}&by=${account.toLowerCase()}`,
        method: "GET",
      });

      const data = response?.deta;
      console.log(response, "Email Verification Check Response");
      if (data?.isFullyVerified) {
        await callRecordEventAgreement(email, true, true);
        handleContinueWithVerifiedMail();
      } else {
        setOtpRequired(true);
      }
    } catch (error) {
      console.error("Error checking verified:", error);
    } finally {
      setLoarder1(false);
      setIsMailVerificationChecked(true);
    }
  };

  const handleSendCode = async () => {
    if (!isValidEmail(email)) {
      setIsValidMail(false);
      return;
    }

    const url = isNewMailRequired
      ? `/emails/verify-email`
      : `/emails/update-email`;

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url,
        method: isNewMailRequired ? "POST" : "PATCH",
        data: {
          by: account.toLowerCase(),
          email: email.trim(),
        },
      });

      console.log(response?.deta, "Send Code Response");

      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        handleContinueWithVerifiedMail();
        await callRecordEventAgreement(email, true, true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        setCodeSentOnce(true);
        toast.success("Verification code sent to your email", {
          className: "verification-toast",
          position: "top-right",
        });

        // Start cooldown
        setIsResendDisabled(true);
        setResendTimer(10);
      }
    } catch (error) {
      console.error("Error updating email:", error);
    } finally {
      setLoarder1(false);
    }
  };

  const handlVerifyCode = async () => {
    console.log("Verifying code:", otp, email);
    if (otp?.trim()?.length === 0 || otp?.trim()?.length !== 6) {
      setIsCodeValid(false);
      return;
    }

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/verify-otp`,
        method: "POST",
        data: {
          email: email.trim(),
          by: account.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
        await callRecordEventAgreement(email, true, true);
        setIsEmailVerified(true);
        console.log("Email verified successfully");
        setIsCodeValid(true);
        handleContinueWithVerifiedMail();
      } else {
        setIsCodeValid(false);
      }
    } catch (error) {
      console.error("Error verifying code:", error);
      setIsCodeValid(false);
    } finally {
      setLoarder1(false);
    }
  };

  const [resendTimer, setResendTimer] = useState();
  useEffect(() => {
    let countdown;
    if (resendTimer > 0) {
      countdown = setTimeout(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [resendTimer, isResendDisabled]);

  const handleContinueWithVerifiedMail = () => {
    handleCloseVerification();
    setEmail(email);
    setOtp("");
    setIsEmailVerified(false);
    setIsNewMailRequired(false);
    setIsValidMail(true);
    setIsMailVerificationChecked(false);
    setOtpRequired(false);
    setIsCodeValid(true);
    setCodeSentOnce(false);
    setIsResendDisabled(false);

    localStorage.setItem(
      "verifiedData",
      JSON.stringify({ address: account, email }),
    );
  };

  const handleContinueWithAnotherEmail = () => {
    setIsEmailVerified(false);
    setEmail(null);
  };

  const callRecordEventAgreement = async (
    email,
    emailVerified = false,
    onlyEmailEvent = false,
  ) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode) return;

    const metaData = {
      ...(!onlyEmailEvent && {
        privateSaleAgreement: [
          {
            email,
            agreedToToS: checkDisclaimer,
            agreedToRoadmapNotice: checkPurchaseDisclaimer,
            agreedToNotUsIsrealCitizen: checkCitizenship,
            agreedToReceiveMarketingEmail: checkMerketing,
            agreedOn: Date.now(),
          },
        ],
      }),
      ...(emailVerified && {
        emailWasVerified: true,
      }),
    };

    await recordEvent(metaData);
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleInputMail = (e) => {
    let value = e.target.value;
    setEmail(value);
    setIsEmailVerified(null);
    setIsValidMail(true);
    setIsMailVerificationChecked(false);
    setOtpRequired(false);
    setCodeSentOnce(false);
    setIsCodeValid(true);
    setOtp("");
  };

  const fetchAllowedTokens = async () => {
    try {
      const response = await axios.get(
        `${API_URL}tokens/allowed?privateSale=${Presale?.apiTag}`,
      );

      if (response?.data?.data) {
        setAllowedTokens(response?.data?.data);
        // console.log("allowed tokens", response?.data?.data);
      }
    } catch (error) {
      console.log("fetch allowed tokens error::", error);
    }
  };

  // const [limitObj, setLimitObj] = useState(null)
  // const [limitObjperc, setLimitObjperc] = useState(null)
  // const [gaugePosition,setGaugePosition] =useState(null);
  // console.log( stakedAmount,discountedPriceee,multiplyPercentNumbere,' Additional Tokens');

  const [show0, setShow0] = useState(false);

  const handleClos0 = async () => {
    setShow0(false);
    if (inputFeild && inputFeild1) {
      // if (chainId !== parseInt(CHAIN)) {
      // let ss = await setupNetwork();
      // if (ss) {
      confirm();
      // }
      // } else {
      //   confirm();
      // }
    }
  };
  const handleShow0 = () => {
    if (PREMIUM_STAKING_FLOW_ENABLED) setShow0(true);
  };
  useEffect(() => {
    if (account) {
      // toast.warning(`round ddfalsdfa, ${chainId}, ${account}, ${CHAIN}`);
      firstTimeData();
      saleStatusss();
      alowence();
      fetchAllowedTokens();
      // uniPriceHandler();
      // linkPriceHnadler();
      // dopPriceHandler();
      // getPepePrice();
      // getTomiPrice();
      // getWbtcCurrentPrice();
    }
  }, [account]);
  useEffect(() => {
    // if (chainId != parseInt(CHAIN)) return;
    if (account) {
      setStakeEndTime1([]);
      balaceOf();
      firstTimeData1();
      balancerOfGems();
      balancerOfUsdc();
      if (PREMIUM_STAKING_FLOW_ENABLED) {
        fetchStakingData();
        fetchStakingData1();
        getGemsStakedAmount();
      }
      // balancerOftomi();
      // balancerOfPepe();
      // balancerOfUni();
      // balancerOfDop();
      // balancerOfLink();
      // balancerOfWbtc();
      // StakeIndec()
    } else {
      setBalanceeUsdt(null);
      setBlanceOfEth(null);
      setBalanceOfUsdc(null);
      // setApprove("")
      setGemsBalance(null);
      setStakeEndTime1([]);
      // setBalanceOfTomi(null);
      // setBalanceOfUnii(null);
      // setBalanceOfDopp(null);
      // setBalanceOfLinkk(null);
      // setBalanceOfPepee(null);
      // setBalanceOfWbtc(null);
    }
  }, [account]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     firstTimeData();
  //     firstTimeData1();
  //   }, 30000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [account]);

  // console.log(sallowance,'sajad',inputFeild);

  const saleStatusss = async () => {
    try {
      let b = await saleStatus();

      // let b1 = await saleStatus1();
      if (b) {
        // console.log(b, "noooor imad");
        // setCurrentRoundd(b)
        // roundData(b)
        setSaleCurrentStaus(b);
        // setSaleCurrentStaus1(b1);
      }
    } catch (err) {
      console.log(err.message, "noooor imad");
    }
  };

  const firstTimeData = async () => {
    setLoarder1(true);
    try {
      let b;
      b = await cuurentRound();
      setRound(b);
      let price = 0;
      if (b) {
        if (b == 1) {
          // setMultiplyPercentNumbere(0.2);
          price = 0.2;
        } else {
          // setMultiplyPercentNumbere(0.07);
          price = 0.07;
        }
        // console.log(b, "cccccccc");
        // setCurrentRoundd(b)
        // console.log("goin into roundData waleed", b, price);
        roundData(b, price);
      }
    } catch (err) {
      console.log(err.message, "nooor");
      setLoarder1(false);
    }
  };
  const firstTimeData11 = async () => {
    try {
      await refreshActivePaymentPrice({ token: mainTag });
    } catch (err) {
      console.log(err.message);
    }
  };
  // const uniPriceHandler = async () => {
  //   try {
  //     let a = await uniPrice();
  //     if (a) {
  //     setUniPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message,'aaa');
  //   }
  // };
  // const uniPriceHandler = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/uni-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       let qw = response?.data?.data;
  //       // setPepePrice(qw)
  //       setUniPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const dopPriceHandler = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/dop-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       let qw = response?.data?.data;
  //       // setPepePrice(qw)
  //       setDopPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const linkPriceHnadler = async () => {
  //   try {
  //     let a = await linkPrice();
  //     if (a) {
  //       setlinkPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };
  // const getPepePrice = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/pepe-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       // console.log(response,'response');
  //       let qw = response?.data?.data;
  //       setPepePrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const getTomiPrice = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/tomi-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       // console.log(response,'response');
  //       let qw = response?.data?.data;
  //       setTomiPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };

  const firstTimeData1 = async () => {
    try {
      var balance = await web3.eth.getBalance(account);
      setBlanceOfEth(balance / 10 ** 18);
    } catch (err) {
      console.log(err.message);
    }
  };

  // const getWbtcCurrentPrice = async () => {
  //   try {
  //     let a = await wbtcPrice();
  //     if (a) {
  //       // console.log(a,'aaa');
  //       setWbtcCurrentPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  const [show1, setShow1] = useState(false);
  const [successModalSpecialSpentUsd, setSuccessModalSpecialSpentUsd] =
    useState(0);
  const [successModalPurchaseUsd, setSuccessModalPurchaseUsd] = useState(0);
  const [buyingNetworkFee, setbuyingNetworkFee] = useState(0);

  async function getGasFeeInUSD(txHash) {
    const receipt = await web3.eth.getTransactionReceipt(txHash);
    const tx = await web3.eth.getTransaction(txHash);

    if (!receipt || !tx) {
      throw new Error("Transaction not found");
    }

    const BN = web3.utils.BN;

    const gasUsed = new BN(receipt.gasUsed);
    const gasPrice = new BN(tx.gasPrice); // effective gas price

    // gasFeeWei = gasUsed * gasPrice
    const feeInWei = gasUsed.mul(gasPrice);

    // Convert wei → ETH (string to avoid precision loss)
    const feeInEth = web3.utils.fromWei(feeInWei, "ether");

    // Convert ETH → USD
    const feeInUsd = Number(feeInEth) * ethPricevalue;
    setbuyingNetworkFee(feeInUsd);
    // return {
    //   gasUsed: receipt.gasUsed,
    //   gasPriceGwei: web3.utils.fromWei(tx.gasPrice, "gwei"),
    //   feeInEth: Number(feeInEth),
    //   feeInUsd
    // };
  }

  const handleClose = () => {
    resetPaymentInputs();
    setbuyingNetworkFee(0);
    setSuccessModalSpecialSpentUsd(0);
    setSuccessModalPurchaseUsd(0);
    setShow1(false);
  };
  const handleShow = () => {
    if (selectedRoundKind === "special") {
      setSuccessModalSpecialSpentUsd(specialSpentUsd);
      setSuccessModalPurchaseUsd(Math.max(0, Number(amountInUsdt) || 0));
    }
    setShow1(true);
  };

  const specialKaiCredits = useMemo(
    () =>
      getKaiCreditsUnlockedBySpecialPurchase(
        remainingCreditUsd,
        successModalSpecialSpentUsd,
        successModalPurchaseUsd,
      ),
    [
      remainingCreditUsd,
      successModalSpecialSpentUsd,
      successModalPurchaseUsd,
    ],
  );

  const changeTag1 = (e) => {
    resetPaymentInputs();

    if (e === "ETH") {
      discoundedPriceee(currentRoundd, Environment.eth);
      setMainTag("ETH");
      setTagImge("/assets/eth-icon.svg");
    } else if (e == "USDT") {
      discoundedPriceee(currentRoundd, Environment.busd);
      setMainTag("USDT");
      setTagImge("/assets/usdt.svg");
    } else if (e == "USDC") {
      discoundedPriceee(currentRoundd, Environment.usdc);
      setMainTag("USDC");
      setTagImge("/assets/usdc.svg");
    } else if (e == "WBTC") {
      discoundedPriceee(currentRoundd, Environment.wbtc);
      setMainTag("WBTC");
      setTagImge("/assets/wbtc.svg");
    } else if (e == "PEPE") {
      discoundedPriceee(currentRoundd, Environment.pepe);
      setMainTag("PEPE");
      setTagImge("/assets/pepe.svg");
    } else if (e == "DOP") {
      discoundedPriceee(currentRoundd, Environment.dop);
      setMainTag("DOP");
      setTagImge("/assets/dop.svg");
    } else if (e == "UNI") {
      discoundedPriceee(currentRoundd, Environment.unisape);
      setMainTag("UNI");
      setTagImge("/assets/uniswap.svg");
    } else if (e == "LINK") {
      discoundedPriceee(currentRoundd, Environment.link);
      setMainTag("LINK");
      setTagImge("/assets/link.svg");
    } else if (e == "TOMI") {
      discoundedPriceee(currentRoundd, Environment.tomi);
      setMainTag("TOMI");
      setTagImge("/assets/tomi-icon-drop.svg");
    } else {
      discoundedPriceee(currentRoundd, Environment.gems);
      setMainTag("GEMS");
      setTagImge("/assets/newgemslogosvg.svg");
    }
  };

  const inputField1Handler = (e) => {
    let raw = e.target.value;

    // Allow empty input
    if (raw === "") {
      resetPaymentInputs();
      return;
    }

    // Allow typing like "0." or "."
    if (!/^\d*\.?\d*$/.test(raw)) return;

    setUserPayInput(raw);

    const value = parseFloat(raw);
    if (isNaN(value)) return;

    let usdValue = 0;
    let payCrypto = value;
    let stablecoinAdjustment = null;

    if (mainTag === "ETH") {
      usdValue = ethPricevalue * value;
    } else if (mainTag === "USDT" || mainTag === "USDC") {
      const px = paymentTokenUsdPrice > 0 ? paymentTokenUsdPrice : 1;
      usdValue = stablecoinPayToUsd(value, px);
      stablecoinAdjustment = getStablecoinMinOrderAdjustment({
        roundKind: selectedRoundKind,
        paymentToken: mainTag,
        paymentTokenUsdPrice: px,
        enteredPayCrypto: value,
        regularMinOrderUsd,
      });
      if (stablecoinAdjustment) {
        payCrypto = stablecoinAdjustment.adjustedPayCrypto;
        usdValue = stablecoinAdjustment.targetUsd;
      }
    } else {
      usdValue = gemsPrice * value;
    }

    const effectivePrice = qualifiesForRegularBulkDiscount(
      selectedRoundKind,
      usdValue,
      regularMinOrderUsd,
    )
      ? getRegularBulkDiscountedPrice(price, regularBulkDiscountRate)
      : price;

    let amount = 0;
    if (mainTag === "ETH") {
      amount = usdValue / effectivePrice;
    } else if (mainTag === "USDT" || mainTag === "USDC") {
      amount = usdValue / effectivePrice;
    } else {
      amount = (gemsPrice * value) / effectivePrice;
    }

    // High-precision normalize
    const preciseAmount = Number(amount.toPrecision(14));

    // Discount difference calc (staking / token-specific price)
    const discountedUnits = usdValue / discountedPriceee;
    const diff = discountedUnits - preciseAmount;

    const payFieldValue =
      stablecoinAdjustment?.adjustedPayCryptoStr ??
      normalizeDecimalString(payCrypto, 6);

    setInputField(payFieldValue);
    setInputField1(normalizeDecimalString(preciseAmount, 6)); // UI display only
    setAmountInUsdt(usdValue);

    setMyInTotlaPurchasess((prev) => prev + preciseAmount);
    setMyPsTotlaPurchasess((prev) => prev + preciseAmount);

    setethValueCalcualte(parseFloat(discountedUnits.toPrecision(12)));

    console.log({
      value,
      amount,
      preciseAmount,
      usdValue,
      discountedUnits,
      diff,
      price,
      amountInUsdt,
      ethPricevalue
    });
  };

  const inputField1Handler1 = (e) => {
    let value = Number(e.target.value);

    if (!value || value <= 0) {
      setInputField1("");
      setInputField("");
      setUserPayInput("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      setAmountInUsdt(0);
      return;
    }

    const listUsd = value * (Number(price) || 0);
    const discountedPaymentUsd =
      listUsd * (1 - regularBulkDiscountRate);
    const useBulkDiscount = qualifiesForRegularBulkDiscount(
      selectedRoundKind,
      discountedPaymentUsd,
      regularMinOrderUsd,
    );

    const effectivePrice = useBulkDiscount
      ? getRegularBulkDiscountedPrice(price, regularBulkDiscountRate)
      : Number(price) || 0;
    const paymentUsd = useBulkDiscount ? discountedPaymentUsd : listUsd;

    let amount = 0;
    const payPx = paymentTokenUsdPrice > 0 ? paymentTokenUsdPrice : 1;
    if (mainTag === "ETH") {
      amount = paymentUsd / payPx;
    } else if (mainTag === "USDT" || mainTag === "USDC") {
      amount = paymentUsd / payPx;
    } else {
      amount = (value * effectivePrice) / gemsPrice;
    }

    // Normalize precision safely
    const preciseAmount = Number(amount.toPrecision(12));

    setInputField1(value);
    setInputField(normalizeDecimalString(preciseAmount, 6)); // UI formatting only
    setAmountInUsdt(paymentUsd);

    setMyInTotlaPurchasess((prev) => prev + preciseAmount);
    setMyPsTotlaPurchasess((prev) => prev + preciseAmount);

    console.log("value:", value, "amount:", amount, "precise:", preciseAmount);
  };

  useEffect(() => {
    const raw =
      userPayInput !== null && userPayInput !== undefined && userPayInput !== ""
        ? userPayInput
        : inputFeild;
    if (raw === "" || raw == null) return;

    const value = parseFloat(raw);
    if (isNaN(value) || value <= 0) return;

    if (mainTag === "USDT" || mainTag === "USDC") {
      const px = paymentTokenUsdPrice > 0 ? paymentTokenUsdPrice : 1;
      let payCrypto = value;
      let usdValue = stablecoinPayToUsd(value, px);

      const adjustment = getStablecoinMinOrderAdjustment({
        roundKind: selectedRoundKind,
        paymentToken: mainTag,
        paymentTokenUsdPrice: px,
        enteredPayCrypto: value,
        regularMinOrderUsd,
      });
      if (adjustment) {
        payCrypto = adjustment.adjustedPayCrypto;
        usdValue = adjustment.targetUsd;
      }

      const effectivePrice = qualifiesForRegularBulkDiscount(
        selectedRoundKind,
        usdValue,
        regularMinOrderUsd,
      )
        ? getRegularBulkDiscountedPrice(price, regularBulkDiscountRate)
        : price;

      const amount = usdValue / effectivePrice;
      const preciseAmount = Number(amount.toPrecision(14));
      const nextPay =
        adjustment?.adjustedPayCryptoStr ?? normalizeDecimalString(payCrypto, 6);
      const nextKai = normalizeDecimalString(preciseAmount, 6);

      if (inputFeild !== nextPay) setInputField(nextPay);
      if (inputFeild1 !== nextKai) setInputField1(nextKai);
      if (amountInUsdt !== usdValue) setAmountInUsdt(usdValue);
      return;
    }

    if (mainTag === "GEMS" || mainTag === "ETH") {
      const px = paymentTokenUsdPrice;
      if (px <= 0) return;

      const usdValue = px * value;
      const effectivePrice = qualifiesForRegularBulkDiscount(
        selectedRoundKind,
        usdValue,
        regularMinOrderUsd,
      )
        ? getRegularBulkDiscountedPrice(price, regularBulkDiscountRate)
        : price;

      const amount = usdValue / effectivePrice;
      const preciseAmount = Number(amount.toPrecision(14));
      const nextKai = normalizeDecimalString(preciseAmount, 6);

      if (inputFeild1 !== nextKai) setInputField1(nextKai);
      if (amountInUsdt !== usdValue) setAmountInUsdt(usdValue);
    }
  }, [
    paymentTokenUsdPrice,
    regularInvestedUsd,
    regularInvestedThresholdUsd,
    regularMinOrderUsd,
    regularBulkDiscountRate,
    selectedRoundKind,
    mainTag,
    price,
    userPayInput,
    inputFeild,
  ]);

  const balaceOf = async () => {
    try {
      let balace = await balacefAccount(account);
      if (balace) {
        // console.log(balace, "Balance");
        setBalanceeUsdt(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // const balancerOftomi = async () => {
  //   try {
  //     let balace = await balacefAccountTomi(account);
  //     if (balace) {
  //       console.log(balace, "tomi erre");
  //       setBalanceOfTomi(balace);
  //     }
  //   } catch (err) {
  //     console.log(err, "tomi erre");
  //   }
  // };
  const balancerOfGems = async () => {
    try {
      let balace = await balacefAccountGems(account);
      if (balace) {
        // console.log(balace, "gems balance");
        setGemsBalance(balace);
      }
    } catch (err) {
      console.log(err, "tomi erre");
    }
  };
  // const balancerOfPepe = async () => {
  //   try {
  //     let balace = await balacefAccountPepe(account);
  //     if (balace) {
  //       setBalanceOfPepee(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfUni = async () => {
  //   try {
  //     let balace = await balacefAccountUni(account);
  //     if (balace) {
  //       setBalanceOfUnii(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfDop = async () => {
  //   try {
  //     let balace = await balacefAccountDop(account);
  //     if (balace) {
  //       setBalanceOfDopp(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfLink = async () => {
  //   try {
  //     let balace = await balacefAccountLink(account);
  //     if (balace) {
  //       setBalanceOfLinkk(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const balancerOfUsdc = async () => {
    try {
      let balace = await balacefAccountUsdc(account);
      if (balace) {
        setBalanceOfUsdc(balace);

      }
    } catch (err) {
      console.log(err);
    }
  };
  // const balancerOfWbtc = async () => {
  //   try {
  //     let balace = await balacefAccountWbtc(account);
  //     if (balace) {
  //       setBalanceOfWbtc(balace);
  //     }
  //   } catch (err) {
  //     console.log(err, "sdsdsdvcv");
  //   }
  // };
  const alowence = async () => {
    try {
      // let insirance = await insurancePercentage();
      // setInsurancePer(insirance / 100);

      // let w134sr = await allowanceGems1();

      // console.log(w134sr, "Gems")
      // setGemsAllwance1(w134sr);
      // let w134s = await allowanceDop1();
      // setDopAllwance1(w134s);
      let was = await allowanceGems();
      setGemsAllwance(was);
      let r = await allowanceTpl();
      setAllowance(r);
      let usdcc = await allowanceUsdc();
      setAllowanceUsdc(usdcc);
      // let wbtcc = await allowanceWbtc();
      // setAllowanceWbtc(wbtcc);
      // let w11 = await allowanceLink();
      // setLinkAllwance(w11);
      // let w134 = await allowanceDop();
      // setDopAllwance(w134);
      // let w22 = await allowancePepe();
      // setPepeAllwance(w22);
      // let w33 = await allowanceUniswape();
      // setUniAllwance(w33);
      // let w = await allowanceTomi();
      // setTomiAllwance(w);
      // let r1 = await allowanceTpl1();
      // setAllowance1(r1);
      // let da = await allowanceTomi1();
      // setTomiAllwance1(da);

      // let usdcc1 = await allowanceUsdc1();
      // setAllowanceUsdc1(usdcc1);
      // let wbtcc1 = await allowanceWbtc1();
      // setAllowanceWbtc1(wbtcc1);
    } catch (err) {
      console.log(err, "nooooer23");
    }
  };

  const callRecordEventTrxTrigger = async (metaData) => {
    await recordEvent(metaData);
  };

  const callRecordEventTrxStatus = async (metaData) => {
    await recordEvent(metaData);
  };

  const handlerPop = async () => {
    if (!navigator.onLine) {
      generateToast("RPC_FAIL");
      return;
    }

    await callRecordEventAgreement(email, true);

    if (!saleValidation.ok) {
      notifyInfo(saleValidation.error);
      return;
    }

    if (inputFeild && inputFeild1) {
      // if (chainId !== parseInt(CHAIN)) {
      //   await setupNetwork(CHAIN);
      // }
      confirm();
    }
  };

  const callRecordEventWalletConnect = async (status) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode || !account) return;

    const metaData = {
      connectWallet: [
        {
          walletAddress: account.toLowerCase(),
          status,
          connectedAt: Date.now(),
        },
      ],
    };

    await recordEvent(metaData);

    localStorage.setItem(
      "walletEvent",
      JSON.stringify({
        logged: true,
        presale: Presale.apiTag,
        account: account.toLowerCase(),
      }),
    );
  };

  const connectMetaMask1 = async () => {
    if (account) {
      try {
        const connectorId = window.localStorage.getItem("connectorId");
        await callRecordEventWalletConnect("disconnected");
        await logout(connectorId);
        clearWalletSession();
        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage.removeItem("verifiedData");
        localStorage.removeItem("hasReloadedAfterConnect");
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("injected");
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        setWalletSession();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    }
  };

  const trustWallet = async () => {
    if (account) {
      try {
        await callRecordEventWalletConnect("disconnected");
        await logout("walletconnect");
        clearWalletSession();
        localStorage.clear();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("walletconnect");
        setWalletSession();
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
      } catch (err) {
        console.log("eerr", err);
        handleError(err);
      }
    }
  };
  const contract = getGemsTokenContract(
    "0xdac17f958d2ee523a2206206994597c13d831ec7",
    web3,
  );
  // async function approve() {
  //    if (chainId !== parseInt(1)) {
  //     await setupNetwork(1)
  //    }
  //   const details = await contract.methods
  //     .approve(
  //       "0xdac17f958d2ee523a2206206994597c13d831ec7",
  //       "1000000000000000000000000",
  //     )
  //     .send({
  //       from: account,
  //       // gas,
  //     });
  // }

  const confirm = async () => {
    setLoarder(true);
    let postApiRes = "";
    var config = "";
    confirmBuyBefore();

    await refreshActivePaymentPrice({ token: mainTag });

    if (mainTag == "TOMI") {
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "TOMI",
          email: email,
          type: "TOKEN",
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    } else if (mainTag == "ETH") {
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "ETH",
          email: email,
          type: "TOKEN",
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    } else if (mainTag == "WBTC") {
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "WBTC",
          email: email,
          type: "TOKEN",
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    } else if (mainTag == "USDC") {
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "USDC",
          email: email,
          // isInsured: checkBoxx,
          type: "TOKEN",
          // buyingAmount: amountInUsdt,
        },
      };
    } else if (mainTag == "UNI") {
      // let pricee= uniPricevalue
      // pricee =parseFloat(pricee).toFixed(6)
      // let amount1 = Math.round((pricee) * 1e12) / 1e12;
      // let nd = web3.utils.toWei(amount1.toString(), "mwei");
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "UNI",
          email: email,
          type: "TOKEN",
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    } else if (mainTag == "LINK") {
      // let pricee= uniPricevalue
      // pricee =parseFloat(pricee).toFixed(6)
      // let amount1 = Math.round((pricee) * 1e12) / 1e12;
      // let nd = web3.utils.toWei(amount1.toString(), "mwei");
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "LINK",
          type: "TOKEN",
          email: email,
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    } else if (mainTag == "PEPE") {
      // let pricee= uniPricevalue
      // pricee =parseFloat(pricee).toFixed(6)
      // let amount1 = Math.round((pricee) * 1e12) / 1e12;
      // let nd = web3.utils.toWei(amount1.toString(), "mwei");
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "PEPE",
          type: "TOKEN",
          email: email,
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    } else if (mainTag == "DOP") {
      // let pricee= uniPricevalue
      // pricee =parseFloat(pricee).toFixed(6)
      // let amount1 = Math.round((pricee) * 1e12) / 1e12;
      // let nd = web3.utils.toWei(amount1.toString(), "mwei");
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "DOP",
          type: "TOKEN",
          email: email,
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    } else if (mainTag === "USDT") {
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "USDT",
          type: "TOKEN",
          email: email,
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    } else {
      config = {
        method: "post",
        url: `${API_URL + Presale?.apiUrl}`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          country: countryBuyer,
          tokenSelected: "GEMS",
          type: "TOKEN",
          email: email,
          // isInsured: checkBoxx,
          // buyingAmount: amountInUsdt,
        },
      };
    }

    postApiRes = await axios(config)
      .then(function (response) {
        return response?.data?.data;
      })
      .catch(function (error) {
        toast.error(error?.response?.data.message);
      });

    if (postApiRes?.isSpecialCode === true) {
      persistSpecialUserFlag(true);
      setIsSpecialUser(true);
    } else if (postApiRes?.isSpecialCode === false) {
      persistSpecialUserFlag(false);
      setIsSpecialUser(false);
    }

    let metaData = {};

    if (mainTag === "ETH") {
      try {
        if (postApiRes) {
          if (saleCurrentStaus) {
            let b = blanceOfEth - parseFloat(inputFeild);
            // console.log(b,'balance',gasPrice/10**9);
            let x = await purchaseEth(
              parseFloat(inputFeild1),
              parseFloat(inputFeild),
              postApiRes,
              currentRoundd,
              b,
              stakeIndex,
              checkBoxx,
              insurancePer,
            );
            if (x) {
              if (checkBoxx) {
                confirmBuy12(x, postApiRes);
              } else {
                confirmBuy(x, postApiRes);
              }

              await getGasFeeInUSD(x?.transactionHash);

              metaData = {
                transactionStatus: [
                  {
                    executed: true,
                    blockchainSuccess: true,
                    ex: "none",
                    transactionHash: x?.transactionHash,
                  },
                ],
              };

              await callRecordEventTrxStatus(metaData);

              setLoarder(false);
              firstTimeData();
              firstTimeData11();
              firstTimeData1();
              balaceOf();
              alowence();
              // capHandler()
              // balaceOf1();
              handleShow();
            }
          } else {
            toast.error("Sale is Currently Paused");
            setLoarder(false);
          }
        } else {
          setLoarder(false);
        }
      } catch (err) {
        console.log(err.message, "errr");

        metaData = {
          transactionStatus: [
            {
              executed: false,
              blockchainSuccess: false,
              ex: err.message,
              transactionHash: "none",
            },
          ],
        };

        await callRecordEventTrxStatus(metaData);

        setLoarder(false);
        handleError(err);
        // toast.error("Transaction reverted:" + err.message);
      }
    } else if (mainTag === "USDT") {
      if (sallowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              let z = await approveTpl(inputFeild, account);
              if (z) {
                let q = await purchaseUsdt(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  await getGasFeeInUSD(q?.transactionHash);

                  metaData = {
                    transactionStatus: [
                      {
                        executed: true,
                        blockchainSuccess: true,
                        ex: "none",
                        transactionHash: q?.transactionHash,
                      },
                    ],
                  };

                  await callRecordEventTrxStatus(metaData);

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.error(err, "err");
          alowence();

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: err.message,
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          setLoarder(false);
          handleError(err);
          // toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild >= sallowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res = await approveTpl(0, account);
                if (res) {
                  let res11 = await approveTpl(inputFeild, account);

                  if (res11) {
                    let q = await purchaseUsdt(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchaseUsdt(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  await getGasFeeInUSD(q?.transactionHash);

                  metaData = {
                    transactionStatus: [
                      {
                        executed: true,
                        blockchainSuccess: true,
                        ex: "none",
                        transactionHash: q?.transactionHash,
                      },
                    ],
                  };

                  await callRecordEventTrxStatus(metaData);

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: err.message,
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          setLoarder(false);
          alowence();
          handleError(err);
          // toast.error("Transaction reverted:" + err.message);
        }
      }
    } else if (mainTag === "USDC") {
      console.log(getAllowanceUsdc, "sallowance");
      if (getAllowanceUsdc === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              let z = await approveTplUsdc(inputFeild, account);
              if (z) {
                let q = await purchaseUsdc(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  await getGasFeeInUSD(q?.transactionHash);

                  metaData = {
                    transactionStatus: [
                      {
                        executed: true,
                        blockchainSuccess: true,
                        ex: "none",
                        transactionHash: q?.transactionHash,
                      },
                    ],
                  };

                  await callRecordEventTrxStatus(metaData);

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  // capHandler()
                  alowence();
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: err.message,
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          alowence();
          setLoarder(false);
          handleError(err);
          // toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild >= getAllowanceUsdc) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res11 = await approveTplUsdc(inputFeild, account);

                if (res11) {
                  let q = await purchaseUsdc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    // balaceOf1();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchaseUsdc(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  await getGasFeeInUSD(q?.transactionHash);

                  metaData = {
                    transactionStatus: [
                      {
                        executed: true,
                        blockchainSuccess: true,
                        ex: "none",
                        transactionHash: q?.transactionHash,
                      },
                    ],
                  };

                  await callRecordEventTrxStatus(metaData);

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: err.message,
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          setLoarder(false);
          alowence();
          handleError(err);
          // toast.error("Transaction reverted:" + err.message);
        }
      }
    } else if (mainTag === "WBTC") {
      if (getAllowanceWbtc === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              console.log(getAllowanceWbtc, mainTag, "sallowance");
              let z = await approveTplwbtc(inputFeild, account);
              if (z) {
                let q = await purchaseWbtc(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  await getGasFeeInUSD(q?.transactionHash);

                  metaData = {
                    transactionStatus: [
                      {
                        executed: true,
                        blockchainSuccess: true,
                        ex: "none",
                        transactionHash: q?.transactionHash,
                      },
                    ],
                  };

                  await callRecordEventTrxStatus(metaData);

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  // capHandler()
                  alowence();
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          alowence();
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild > getAllowanceWbtc) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res11 = await approveTplwbtc(inputFeild, account);

                if (res11) {
                  let q = await purchaseWbtc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    // balaceOf1();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchaseWbtc(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  await getGasFeeInUSD(q?.transactionHash);

                  metaData = {
                    transactionStatus: [
                      {
                        executed: true,
                        blockchainSuccess: true,
                        ex: "none",
                        transactionHash: q?.transactionHash,
                      },
                    ],
                  };

                  await callRecordEventTrxStatus(metaData);

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted:" + err.message);
        }
      }
    } else if (mainTag === "LINK") {
      console.log(mainTag, linkAllowance, "sdsdsds");
      if (linkAllowance === 0) {
        try {
          let z = await approveLink(inputFeild, account);
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (z) {
                let q = await purchaseLink(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          alowence();
          console.log(err, "err");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild > linkAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res11 = await approveLink(inputFeild, account);

                if (res11) {
                  let q = await purchaseLink(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    // balaceOf1();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchaseLink(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          alowence();
          console.log(err, "errr");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      }
    } else if (mainTag === "PEPE") {
      if (pepeAllowance === 0) {
        try {
          let z = await approvePepe(inputFeild, account);
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (z) {
                let q = await purchasePepe(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          alowence();
          console.log(err, "err");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild > pepeAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res11 = await approvePepe(inputFeild, account);

                if (res11) {
                  let q = await purchasePepe(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    // balaceOf1();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchasePepe(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          alowence();
          console.log(err, "errr");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      }
    } else if (mainTag === "DOP") {
      if (dopAllowance === 0) {
        try {
          let z = await approveDop(inputFeild, account);
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (z) {
                let q = await purchaseDop(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          alowence();
          console.log(err, "err");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild > dopAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res11 = await approveDop(inputFeild, account);

                if (res11) {
                  let q = await purchaseDop(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    // balaceOf1();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchaseDop(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          alowence();
          console.log(err, "errr");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      }
    } else if (mainTag === "UNI") {
      if (uniAllowance === 0) {
        try {
          let z = await approveUnisawape(inputFeild, account);
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (z) {
                let q = await purchaseUniswape(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          alowence();
          console.log(err, "err");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild > uniAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res11 = await approveUnisawape(inputFeild, account);

                if (res11) {
                  let q = await purchaseUniswape(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    // balaceOf1();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchaseUniswape(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          alowence();
          console.log(err, "errr");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      }
    } else if (mainTag === "TOMI") {
      if (tomiAllowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              let z = await approveTomi(inputFeild, account);
              if (z) {
                let q = await purchaseTomi(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  // capHandler()
                  alowence();
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          alowence();
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild > tomiAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res11 = await approveTomi(inputFeild, account);

                if (res11) {
                  let q = await purchaseTomi(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    // balaceOf1();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchaseTomi(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }
                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          alowence();
          toast.error("Transaction reverted:" + err.message);
        }
      }
    } else {
      if (gemsAllowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              let z = await approveGems(inputFeild, account);
              if (z) {
                let q = await purchaseGems(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  await getGasFeeInUSD(q?.transactionHash);

                  metaData = {
                    transactionStatus: [
                      {
                        executed: true,
                        blockchainSuccess: true,
                        ex: "none",
                        transactionHash: q?.transactionHash,
                      },
                    ],
                  };

                  await callRecordEventTrxStatus(metaData);

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  // capHandler()
                  alowence();
                  handleShow();
                }
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: err.message,
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          alowence();
          setLoarder(false);
          handleError(err);
          // toast.error("Transaction reverted:" + err.message);
        }
      } else {
        try {
          if (inputFeild > gemsAllowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let res11 = await approveGems(inputFeild, account);

                if (res11) {
                  let q = await purchaseGems(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    // balaceOf1();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let q = await purchaseGems(
                  inputFeild,
                  postApiRes,
                  currentRoundd,
                  blanceOfEth,
                  parseFloat(inputFeild1),
                  stakeIndex,
                  checkBoxx,
                  insurancePer,
                );
                if (q) {
                  if (checkBoxx) {
                    confirmBuy12(q, postApiRes);
                  } else {
                    confirmBuy(q, postApiRes);
                  }

                  await getGasFeeInUSD(q?.transactionHash);

                  metaData = {
                    transactionStatus: [
                      {
                        executed: true,
                        blockchainSuccess: true,
                        ex: "none",
                        transactionHash: q?.transactionHash,
                      },
                    ],
                  };

                  await callRecordEventTrxStatus(metaData);

                  setLoarder(false);
                  firstTimeData();
                  firstTimeData11();
                  firstTimeData1();
                  balaceOf();
                  alowence();
                  // capHandler()
                  handleShow();
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: err.message,
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          setLoarder(false);
          alowence();
          handleError(err);
          // toast.error("Transaction reverted:" + err.message);
        }
      }
    }
  };

  const userLogin1 = async (e) => {
    // setLoarder(true);
    discoundedPriceee(e, Environment?.eth);
    let b = tab === "home" ? "sale-rounds/users" : "sale-rounds/users-nft";
    await axios
      .get(API_URL + b)
      .then(async (res) => {
        // setLoarder(false);
        let a = res.data.data;
        // console.log(a, 'aaaa', e);
        a.map((i) => {
          if (e == i?.round && i.privateSale == Presale?.apiTag) {
            setNicName(i.round);
          }
        });

        setTimeout(() => {
          // console.log("Delayed for 1 second.");
          setLoarder1(false);
        }, "1000");
        // calucation(res.data.data)
        // console.log(res.data.data,'res.data.data');
      })
      .catch((err) => {
        console.log(err, "err");
        setLoarder1(false);
        // setLoarder(false);
      });
  };

  useEffect(() => {
    // console.log('usefffef',email,code);
    if (!code) {
      history.push("/");
    }
    setIsSpecialUser(readSpecialUserFlag());
  }, [code]);

  const roundData = async (e, pppp) => {
    try {
      if (parseInt(e) <= 1) {
        // Handle single round case
        const roundInfo = tab === "home" ? await timer(e) : await timerNft(e);

        if (roundInfo) {
          updateRoundState(roundInfo, e);
        }
      } else {
        // Start from current round and go backwards to find active round
        let activeRound = null;
        let roundNumber = null;

        // Check rounds from current (e) down to 1
        for (let i = parseInt(e); i >= 1; i--) {
          const roundInfo = tab === "home" ? await timer(i) : await timerNft(i);

          // Check if this round is currently active
          if (
            currentTime > parseInt(roundInfo.startTime) &&
            currentTime < parseInt(roundInfo.endTime)
          ) {
            activeRound = roundInfo;
            roundNumber = i;
            break; // Found active round, stop searching
          }

          // Store first round for fallback
          if (!activeRound) {
            activeRound = roundInfo;
            roundNumber = i;
          }
        }

        // If no active round found, find the closest one
        if (
          !activeRound ||
          currentTime < parseInt(activeRound.startTime) ||
          currentTime > parseInt(activeRound.endTime)
        ) {
          const allRounds = await fetchAllRounds(e);
          activeRound = findClosestRound(allRounds);
          roundNumber = activeRound.roundNumber;
        }

        updateRoundState(activeRound, roundNumber);
      }
    } catch (err) {
      console.log(err, "error in roundData");
      setLoarder1(false);
    }
  };

  // Helper function to fetch all rounds if needed
  const fetchAllRounds = async (maxRound) => {
    const rounds = [];
    for (let i = 1; i <= maxRound; i++) {
      const roundInfo = tab === "home" ? await timer(i) : await timerNft(i);
      rounds.push({ ...roundInfo, roundNumber: i });
    }
    return rounds;
  };

  // Helper function to find closest round
  const findClosestRound = (rounds) => {
    let closestRound = null;
    let minDiff = Infinity;

    rounds.forEach((round) => {
      const diff = Math.abs(currentTime - parseInt(round.startTime));
      if (diff < minDiff) {
        minDiff = diff;
        closestRound = round;
      }
    });

    return closestRound;
  };

  // Helper function to update state
  const updateRoundState = (roundInfo, roundNumber) => {
    const enriched = enrichRoundWithKind(roundInfo);
    setCurrentRount(enriched);
    const kind = enriched?.roundKind || "regular";
    setSelectedRoundKind(kind);
    localStorage.setItem("selectedRoundKind", kind);
    setCurrentRoundd(roundNumber);
    localStorage.setItem("currentRunningRound", roundNumber);

    const basePrice = roundInfo.price / 10 ** 18;
    const discount = roundNumber == 1 ? 0.2 : 0.07;
    const discountedPrice = basePrice * (1 - discount);

    setPrice(basePrice);
    setCopyOfPrice(basePrice);
    setMultiplyPercentNumbere(discount);
    setDiscountedPriceee(discountedPrice);

    userLogin1(roundNumber);

    setTimeout(() => setLoarder1(false), 1000);
  };

  const confirmBuy12 = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        dopPurchased:
          hasPremiumStakingPerks ? nereValue : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price: Number(purchasePriceForApi || 0).toFixed(4),
        privateSale: Presale?.apiTag,
        recipient: account,
        isInsured: true,
        buyingAmountUsd: amountInUsdt?.toFixed(4),
        insuranceFee: parseFloat(inputFeild * insurancePer)?.toFixed(4),
        insuranceFeeUsd: parseFloat(amountInUsdt * insurancePer)?.toFixed(4),
        totalBuyingAmount: parseFloat(
          parseFloat(inputFeild) + parseFloat(inputFeild * insurancePer),
        )?.toFixed(4),
        totalBuyingAmountUsd: parseFloat(
          parseFloat(amountInUsdt) + parseFloat(amountInUsdt * insurancePer),
        )?.toFixed(4),
      },
    };

    const postApiRes = await axios(config)
      .then(function (response) {
        refetchPresaleLimits();
        if (isSpecialRound) refetchCreditBalance();
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuy = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const normalisedCoinName = Presale?.name.replaceAll(" ", "").toLowerCase();

    const stored = localStorage.getItem("walletMongoId");
    const cached = stored ? JSON.parse(stored) : null;
    const userIdForAnalytics = cached?.mongoId || "";
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "purchase",
      event_label: `${normalisedCoinName}`,
      ecommerce: {
        transaction_id: dataaa?.transactionHash,
        value: parseFloat(amountInUsdt)?.toFixed(4), // Always in USD (for reporting)
        currency: "USD",
        items: [
          {
            item_id: Presale?.name,
            item_name: `${Presale?.apiTag} Token`,
            quantity:
              hasPremiumStakingPerks ? nereValue : inputFeild1,
          },
        ],
      },
      paid_with: mainTag, // Payment currency
      paid_amount: parseFloat(inputFeild), // Amount paid
      user_id: userIdForAnalytics,
      coin_name: `buy${normalisedCoinName}`,
    });

    // console.log("Pushed purchase event to dataLayer: waleed", window.dataLayer);

    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          hasPremiumStakingPerks ? nereValue : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price: Number(purchasePriceForApi || 0).toFixed(4),
        privateSale: Presale?.apiTag,
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        refetchPresaleLimits();
        if (isSpecialRound) refetchCreditBalance();
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuyBefore = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const config = {
      method: "post",
      url: `${API_URL}emails/temp`,
      data: {
        accessCode: code,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          hasPremiumStakingPerks ? nereValue : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price: Number(purchasePriceForApi || 0).toFixed(4),
        privateSale: Presale?.apiTag,
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };

    const metaData = {
      purchaseTxn: [
        {
          type: "TOKEN",
          nft: "none",
          amountInvested: parseFloat(inputFeild),
          tokenSelected: mainTag,
          tokensReceived:
            hasPremiumStakingPerks ? nereValue : inputFeild1,
          dollarAmount: parseFloat(amountInUsdt)?.toFixed(4),
        },
      ],
    };

    await callRecordEventTrxTrigger(metaData);

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };

  const tabHandler = (e) => {
    if (selectedRoundKind === "gems") {
      discoundedPriceee(currentRoundd, Environment.gems);
      setMainTag("GEMS");
      setTagImge("/assets/newgemslogosvg.svg");
    } else {
      discoundedPriceee(currentRoundd, Environment.eth);
      setMainTag("ETH");
      setTagImge("/assets/eth-icon.svg");
    }
    if (tab == "home") {
      setTab("profile");
    } else {
      setTab("home");
    }
  };
  // console.log(price,'buy price');
  const discoundedPriceee = async (aa, e) => {
    // console.log(a,e,'a,e');
    try {
      let ab = await discountedPrice(aa, e);
      // console.log('buy',ab,copyOfPrice);
      if (ab > 0) {
        // console.log('if chala');
        setPrice(ab);
        let b = ab;
        let c = b * multiplyPercentNumbere;
        let v = b - c;
        setDiscountedPriceee(v);
        setPercet(100 * ((copyOfPrice - ab) / copyOfPrice));
        console.log(ab, e, "callll ho raHA ");
        setPriceCheck(true);
      } else {
        if (copyOfPrice) {
          setPriceCheck(false);
          setPrice(copyOfPrice);
          let b = copyOfPrice;
          let c = b * multiplyPercentNumbere;
          let v = b - c;
          setDiscountedPriceee(v);
        }
      }
    } catch (err) {
      console.log(err, "discoundedPrice err");
    }
  };

  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleTooltipMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleTooltipMouseLeave = () => {
    setShowTooltip(false);
  };

  // useEffect(() => {
  //   setInterval(() => {
  //     fetchStakingData()
  //   }, 30000);
  // }, [])
  // const apiCheck = async (e) => {

  //   const data = {
  //     accessCode: code,
  //   };
  //   await axios
  //     .post(API_URL + "users/verify-code", data)
  //     .then(async (res) => {
  //       setLimitObj(res.data.data.limit)
  //       let a = parseInt(res.data.data.limit.buyingLimit)
  //       let b = parseInt(res.data.data.limit.saleCount)
  //       let c = (b / a) * 100
  //       const clampedValue = Math.min(100, Math.max(0, c));
  //       setGaugePosition(`${clampedValue}%`)
  //       setLimitObjperc(c)
  //       let dd = JSON.stringify(res.data.data.limit)
  //       localStorage?.setItem("oobjj", dd);
  //     })
  //     .catch((err) => {
  //       console.log(err, "err");

  //     });
  // }

  const fetchStakingData = async () => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        stakeds(where: {isClaimed: false, staker: "${account}"}) {
          stakerStakeIndex
          transactionHash
          stakeEndTime
          staker
          isClaimed
          id
          blockTimestamp
          blockNumber
          amount
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: Environment.gemsLockingGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        console.log(response, "response");

        const resData = response?.data?.data?.stakeds;
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          // console.log(a, 'mainn1');
          let bcc = a?.sort();
          setStakeIndux(bcc);
          setStakingData(resData);
          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(
            resData[resData?.length - 1]?.stakeEndTime,
          );
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
          if (!endTimeStamp.isValid()) {
            setStakeEndTime(currentTime);
          } else {
            setStakeEndTime(endTimeStamp);
          }
          // setLoarder1(false)
        }
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };

  const fetchStakingData1 = async (useV2 = false) => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
  subscribeds(where: {by: "${account}"}, orderBy: blockTimestamp, orderDirection: desc) {
      blockTimestamp
      blockNumber
      amountPurchased
      by
      endTime
      id
      tokenPrice
      transactionHash
    }
  }`,
      variables: {},
    });

    var config = {
      method: "post",
      url: useV2
        ? Environment.gemSubscriptionMultiple
        : Environment.gemsSubscribeGrap,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(config)
      .then(async function (response) {
        const resData = response?.data?.data?.subscribeds;
        // console.log("43353453454", resData);
        if ((!resData || resData.length === 0) && !useV2) {
          return fetchStakingData1(true);
        }
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          let bcc = a?.sort();
          // setStakeIndux(bcc);
          setStakingData1(resData[0]);

          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds

          if (!endTimeStamp.isValid() || currentTime.isAfter(endTimeStamp)) {
            if (!useV2) {
              // Try again with gemSubscriptionMultiple
              return fetchStakingData1(true);
            } else {
              setStakeEndTime1(currentTime);
            }
          } else {
            setStakeEndTime1(endTimeStamp);
          }
          // setLoarder1(false)
        }
        // setLoarder1(false);
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };

  //   const StakeIndec=async()=>{
  //     const bal = await getGemsStakedIndex(account);
  //     console.log(bal, 'bal');
  //     if (bal !== null || bal !== undefined) {
  //       if(bal==0){
  //         setStakeIndux([])
  //       }else{
  //         setStakeIndux([parseInt(bal)-1])
  //       }

  //     }
  //  }

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(account);

    if (staked) {
      setStakedAmount(staked);
    }
  };

  const tokenImages = {
    ETH: "/assets/eth-icon.svg",
    USDT: "/assets/usdt.svg",
    DOP: "/assets/dop.svg",
    GEMS: "/assets/newgemslogosvg.svg",
    TOMI: "/assets/tomi-icon-drop.svg",
    USDC: "/assets/usdc.svg",
    WBTC: "/assets/wbtc.svg",
    LINK: "/assets/link.svg", // ✅ added
    UNI: "/assets/uni.svg",
    PEPE: "/assets/pepe.svg", // ✅ added
  };

  // console.log("maintagggg 6/8/12:50", chainId, parseInt(CHAIN), account, mainTag, email,);

  return (
    <>
      {loaderr1 && <Loader />}
      {loaderr && <Loader text={"Sign the transaction in your wallet"} />}
      <Navbar setShow={setShow} />
      <section className="main-banner">
        <img
          src="/assets/leftshade.png"
          alt="leftshade"
          className="leftshade"
        />
        <img
          src="/assets/rightshade.png"
          alt="rightshade"
          className="rightshade"
        />
        {/* <img
          src="\assets\homepage-bg.png"
          alt="img"
          className="img-fluid banner-bg"
        />
        <img
          src="\assets\mblviewbg.png"
          alt="img"
          className="img-fluid mblviewbanner-bg d-none"
        /> */}
        <div className="container">
          <div className="banner-content">
            <div className="timermain">
              <div className="innertimer">
                <div className="timerleft">
                  <div className="mainiconimg">
                    {/* <button onClick={approve}>confirm 0.3</button> */}
                    <img
                      src={Presale?.image}
                      alt="iconimginner"
                      className="iconimginner"
                    />
                  </div>
                  <div className="mainicontexts">
                    <h6 className="timerhead">{Presale?.name}</h6>
                    <>
                      {currentTime <
                        new Date(parseInt(currentRount?.startTime)) ? (
                        <p className="timerpara">
                          Round {niceName} Starts in:
                        </p>
                      ) : (
                        <>
                          {currentTime >
                            new Date(parseInt(currentRount?.startTime)) &&
                            currentTime <
                            new Date(parseInt(currentRount?.endTime)) ? (
                            <p className="timerpara">
                              Round {niceName} Ends in:
                            </p>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </>
                  </div>
                </div>
                <>
                  {timeshow ? (
                    <p className="timerended">Sale ended!</p>
                  ) : (
                    currentRount !== null &&
                    currentRount !== undefined && (
                      <>
                        <RoundTimer
                          currentRount={currentRount}
                          currentTime={currentTime}
                          setTimeshow={setTimeshow}
                          startTime11={startTime11}
                          history={history}
                          timeshow={timeshow}
                        />
                      </>
                    )
                  )}
                </>
              </div>
              <div className="detailmain">
                <p className="detailpara">
                  Want to learn more about the project?{" "}
                  <a
                    href={`https://gems.vip/${Presale?.detailPage?.toLowerCase()}`}
                    target="_blank"
                    className="greenlink"
                  >
                    Project Details Page
                  </a>
                </p>
              </div>
            </div>

            <div className="twice-content">
              <div className="upper-content">
                <div className="left">
                  <img
                    src={Presale?.image}
                    alt="img"
                    className="img-fluid tokennnimmgg"
                  />
                  <div className="text">
                    <h6>{Presale?.name}</h6>
                    <p>${Presale?.symbol}</p>
                  </div>
                </div>
                <div className="right">
                  <>
                    <>
                      {priceCheck || hasPremiumStakingPerks ? (
                        <>
                          {console.log("special offer chal rha hai", {
                            priceCheck,
                            stakedAmount,
                            stakingData,
                            stakeendtime: moment().isBefore(stakeEndTime1),
                            hasPremiumStakingPerks,
                            premiumStakingFlowEnabled: PREMIUM_STAKING_FLOW_ENABLED,
                          })}
                          {hasPremiumStakingPerks ? (
                            <div className="right-text-content">
                              <div className="inner-left">
                                <h5>Special offer</h5>
                                <p className="special-para">
                                  You save {currentRoundd == 1 ? "20" : "7"}%
                                  {priceCheck ? `+ ${parseInt(percent)}%` : ""}
                                </p>
                              </div>
                              <div className="inner-right">
                                <h6>
                                  {" "}
                                  <h6>
                                    $
                                    {discountedPriceee
                                      ? formatDisplayPrice(discountedPriceee)
                                      : "0"}{" "}
                                    USD
                                  </h6>
                                </h6>
                                <p>${formatDisplayPrice(price)}</p>
                              </div>
                            </div>
                          ) : !hasPremiumStakingPerks ? (
                            <h6>
                              ${price ? formatDisplayPrice(price) : "0"}{" "}
                              USD
                            </h6>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <h6>
                          ${price ? formatDisplayPrice(price) : "0"} USD
                        </h6>
                      )}
                    </>
                  </>
                </div>
              </div>
            </div>
            {selectedRoundKind === "regular" && <div className="sale-limit-box">
              {/* <div className="single-box">
                <div className="inner-left">
                  <div className="main-img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M2 10H22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6>You can purchase up to <span>${fmtUsd(regularInvestedThresholdUsd)}</span> in KAI in this Sale.</h6>
                </div>
                <div className="info-box">
                  <p>Sale LIMIT</p>
                </div>
              </div>
              <div className="middle-line">
                <img src="\assets\line.png" alt="img" className="img-fluid" />
                <p>OR</p>
                <img src="\assets\line.png" alt="img" className="img-fluid" />
              </div> */}
              <div className="single-box">
                <div className="inner-left">
                  <div className="main-img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M19 5L5 19" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.5 9C7.88071 9 9 7.88071 9 6.5C9 5.11929 7.88071 4 6.5 4C5.11929 4 4 5.11929 4 6.5C4 7.88071 5.11929 9 6.5 9Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M17.5 20C18.8807 20 20 18.8807 20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6>Buy <span>${fmtUsd(regularMinOrderUsd)}+</span> in a single transaction and get a <span>{regularBulkDiscountPercent}% discount.</span></h6>
                </div>
                <div className="info-box green-box">
                  <p>sAVE {regularBulkDiscountPercent}%</p>
                </div>
              </div>
            </div>}
            {selectedRoundKind === "gems" && <div className="sale-limit-box">
              <div className="single-box">
                <div className="inner-left">
                  <div className="main-img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M10.5 3L8 9L12 22L16 9L13.5 3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M17.0003 3C17.3108 3 17.617 3.07229 17.8948 3.21115C18.1725 3.35 18.414 3.55161 18.6003 3.8L21.6003 7.8C21.8576 8.14316 21.9978 8.55995 22.0001 8.98885C22.0025 9.41776 21.8669 9.83605 21.6133 10.182L13.6233 21.168C13.4381 21.4255 13.1943 21.6352 12.912 21.7799C12.6297 21.9245 12.317 22 11.9998 22C11.6826 22 11.37 21.9245 11.0877 21.7799C10.8054 21.6352 10.5616 21.4255 10.3763 21.168L2.38633 10.182C2.13294 9.83594 1.99751 9.41759 2.00003 8.98869C2.00256 8.55979 2.14289 8.14306 2.40033 7.8L5.39833 3.803C5.58451 3.55379 5.82626 3.35144 6.10437 3.21204C6.38247 3.07264 6.68925 3.00004 7.00033 3H17.0003Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M2 9H22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6>Exclusive to <span>GEMS holders</span> - pay with <span>GEMS Token</span> only.</h6>
                </div>
                <div className="info-box green-box">
                  <p>gems only round</p>
                </div>
              </div>
              <div className="middle-line">
                <img src="\assets\line.png" alt="img" className="img-fluid" />
              </div>
              <div className="single-box">
                <div className="inner-left">
                  <div className="main-img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M2 10H22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6>You can purchase up to <span>${fmtUsd(gemsRoundUsdCap)}</span> in GEMS tokens, and get <span>${fmtUsd(gemsRoundUsdCap)}</span> in $KAI tokens, per user.</h6>
                </div>
                <div className="info-box">
                  <p>Round limit</p>
                </div>
              </div>
            </div>}
            {selectedRoundKind === "special" && <div className="sale-limit-box">
              <div className="single-box">
                <div className="inner-left">
                  <div className="main-img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M2 10H22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6>You can invest up to <span>${fmtUsd(specialRoundUsdCap)}</span> per user in this round</h6>
                </div>
                <div className="info-box">
                  <p>Round limit</p>
                </div>
              </div>
              <div className="middle-line">
                <img src="\assets\line.png" alt="img" className="img-fluid" />
              </div>
              <div className="single-box">
                <div className="inner-left">
                  <div className="main-img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M16 3L20 7L16 11" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M20 7H4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M8 21L4 17L8 13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4 17H20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6>Each <span>$1</span> invested grants permission to use <span>1 credit</span> to buy $KAI (<span>1:1</span> ratio).</h6>
                </div>
                <div className="info-box green-box">
                  <p>Credit unlock</p>
                </div>
              </div>
              <div className="middle-line">
                <img src="\assets\line.png" alt="img" className="img-fluid" />
              </div>
              <div className="single-box">
                <div className="inner-left">
                  <div className="main-img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M12 16V12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M12 8H12.01" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6>Unlocks permission for <span>existing credits only</span> - this round does not grant new credits.</h6>
                </div>
                <div className="info-box">
                  <p>Important</p>
                </div>
              </div>
              <div className="middle-line">
                <img src="\assets\line.png" alt="img" className="img-fluid" />
              </div>
              <div className="single-box">
                <div className="inner-left">
                  <div className="main-img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M11.5248 2.29489C11.5687 2.20635 11.6364 2.13183 11.7203 2.07972C11.8042 2.02761 11.9011 2 11.9998 2C12.0986 2 12.1955 2.02761 12.2794 2.07972C12.3633 2.13183 12.431 2.20635 12.4748 2.29489L14.7848 6.97389C14.937 7.28186 15.1617 7.5483 15.4395 7.75035C15.7173 7.95239 16.04 8.08401 16.3798 8.13389L21.5458 8.88989C21.6437 8.90408 21.7357 8.94537 21.8113 9.00909C21.887 9.07282 21.9433 9.15644 21.9739 9.2505C22.0045 9.34456 22.0081 9.4453 21.9844 9.54133C21.9607 9.63736 21.9107 9.72485 21.8398 9.79389L18.1038 13.4319C17.8575 13.672 17.6731 13.9684 17.5667 14.2955C17.4602 14.6227 17.4349 14.9708 17.4928 15.3099L18.3748 20.4499C18.3921 20.5477 18.3816 20.6485 18.3443 20.7406C18.3071 20.8327 18.2448 20.9125 18.1644 20.9709C18.084 21.0293 17.9888 21.0639 17.8897 21.0708C17.7906 21.0777 17.6915 21.0566 17.6038 21.0099L12.9858 18.5819C12.6816 18.4221 12.343 18.3386 11.9993 18.3386C11.6557 18.3386 11.3171 18.4221 11.0128 18.5819L6.39585 21.0099C6.30818 21.0563 6.20924 21.0772 6.1103 21.0701C6.01135 21.0631 5.91636 21.0285 5.83614 20.9701C5.75592 20.9118 5.69368 20.8321 5.6565 20.7401C5.61933 20.6482 5.6087 20.5476 5.62585 20.4499L6.50685 15.3109C6.56504 14.9716 6.53983 14.6233 6.43338 14.2959C6.32694 13.9686 6.14245 13.672 5.89585 13.4319L2.15985 9.79489C2.08844 9.72593 2.03784 9.63829 2.01381 9.54197C1.98978 9.44565 1.99328 9.34451 2.02393 9.25008C2.05457 9.15566 2.11111 9.07174 2.18712 9.00788C2.26313 8.94402 2.35555 8.90279 2.45385 8.88889L7.61885 8.13389C7.9591 8.08439 8.28224 7.95295 8.56043 7.75088C8.83863 7.54881 9.06355 7.28216 9.21585 6.97389L11.5248 2.29489Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <h6>You must be a <span>Premium User</span> to use the credits unlockes in this round.</h6>
                </div>
                <div className="info-box green-box">
                  <p>Premium User</p>
                </div>
              </div>
            </div>}
            <div className="discount-offer-removed"></div>
            <div className="custom-tabs">
              <Tabs
                defaultActiveKey={tab}
                id="uncontrolled-tab-example"
                onSelect={tabHandler}
              >
                <Tab eventKey="home" title="Buy Token">
                  <div className="bottom-content">
                    <div className="twice-contentt">
                      <h6 className="main-head m-0">
                        Buy ${Presale?.symbol}
                      </h6>
                      <h6 style={{ fontFamily: "hsemibold" }}>
                        Your Balance:{" "}
                        {mainTag === "ETH"
                          ? blanceOfEth > 0
                            ? formatDisplayPaymentAmount(blanceOfEth)
                            : "0"
                          : mainTag === "USDT"
                            ? balanceeUsdt > 0
                              ? formatDisplayPaymentAmount(balanceeUsdt)
                              : "0"
                            : mainTag === "USDC"
                              ? balaceOfUsdc > 0
                                ? formatDisplayPaymentAmount(balaceOfUsdc)
                                : "0"
                              : mainTag === "WBTC"
                                ? balaceOfWbtc > 0
                                  ? formatDisplayNumber(balaceOfWbtc, 6)
                                  : "0"
                                : mainTag === "UNI"
                                  ? balaceOfUnii > 0
                                    ? formatDisplayNumber(balaceOfUnii, 6)
                                    : "0"
                                  : mainTag === "LINK"
                                    ? balaceOfLinkk > 0
                                      ? formatDisplayNumber(balaceOfLinkk, 6)
                                      : "0"
                                    : mainTag === "PEPE"
                                      ? balaceOfPepee > 0
                                        ? formatDisplayNumber(balaceOfPepee, 6)
                                        : "0"
                                      : mainTag === "DOP"
                                        ? balaceOfDoppp > 0
                                          ? formatDisplayNumber(balaceOfDoppp, 6)
                                          : "0"
                                        : mainTag === "TOMI"
                                          ? balaceOfTmi > 0
                                            ? formatDisplayPaymentAmount(
                                              balaceOfTmi,
                                            )
                                            : "0"
                                          : gemsBalance > 0
                                            ? formatDisplayPaymentAmount(
                                              gemsBalance,
                                            )
                                            : "0"}{" "}
                        {mainTag === "ETH"
                          ? " ETH "
                          : mainTag === "USDT"
                            ? " USDT "
                            : mainTag === "USDC"
                              ? "USDC"
                              : mainTag === "WBTC"
                                ? "WBTC"
                                : mainTag === "UNI"
                                  ? "UNI"
                                  : mainTag === "LINK"
                                    ? "LINK"
                                    : mainTag === "PEPE"
                                      ? "PEPE"
                                      : mainTag === "DOP"
                                        ? "DOP"
                                        : mainTag === "TOMI"
                                          ? "TOMI"
                                          : "GEMS"}
                      </h6>
                    </div>

                    <div className="parent-box">
                      {
                        !roundLimitErrorMessage && !roundLimitHintMessage && (
                          <img
                            src="\assets\swap-arrow.svg"
                            alt="img"
                            className="img-fluid swap-arrow"
                          />
                        )
                      }

                      <div className={`inner-box ${roundLimitErrorMessage ? "error" : roundLimitHintMessage ? "hint" : ""}`}>
                        {" "}
                        <div className="left">
                          <div class="dropdown">
                            <button
                              class="dropdown-toggle"
                              type="button"
                              data-toggle={
                                selectedRoundKind !== "gems" ? "dropdown" : undefined
                              }
                              aria-expanded="false"
                            >
                              <div className="flexset">
                                <img
                                  src={tagImge}
                                  alt="img"
                                  className="img-fluid suxvsvsyucsusc"
                                />
                                <div className="text">
                                  <h6>{mainTag}</h6>
                                </div>
                              </div>
                              {selectedRoundKind !== "gems" ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="8"
                                  height="5"
                                  viewBox="0 0 8 5"
                                  fill="none"
                                >
                                  <path
                                    d="M7.81779 1.29713L5.9829 3.24602L4.86253 4.44207C4.38809 4.94599 3.61641 4.94599 3.14197 4.44207L0.181004 1.29713C-0.207694 0.88428 0.0723969 0.180007 0.615431 0.180007H3.82219H7.38336C7.93211 0.180007 8.20648 0.88428 7.81779 1.29713Z"
                                    fill="#02171D"
                                  />
                                </svg>
                              ) : null}
                            </button>
                            {selectedRoundKind != "gems" && <ul class="dropdown-menu">
                              {allowedTokens.map((token) => (
                                <li key={token.symbol}>
                                  <a
                                    className="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1(token.symbol)}
                                  >
                                    <img
                                      src={
                                        tokenImages[token.symbol] ||
                                        "/assets/default.svg"
                                      }
                                      alt={token.symbol}
                                      className="img-fluid"
                                    />{" "}
                                    {token.symbol}
                                  </a>
                                </li>
                              ))}
                            </ul>}
                          </div>
                        </div>
                        <div className="right">
                          <h6>
                            $
                            {inputFeild1 && inputFeild
                              ? formatDisplayUsd(paymentInputUsdDisplay, 2)
                              : "0"}
                          </h6>
                          <input
                            onChange={inputField1Handler}
                            value={payInputDisplayValue}
                            onWheel={(e) => e.target.blur()}
                            type="number"
                            placeholder="0.00"
                          />
                          {/* <p>0.00</p> */}
                        </div>
                      </div>
                      {roundLimitErrorMessage ? (
                        <p className="error-text-styling">
                          {roundLimitErrorMessage}
                        </p>
                      ) : null}
                      {roundLimitHintMessage ? (
                        <p className="presale-hint-text-styling">
                          {roundLimitHintMessage}
                        </p>
                      ) : null}
                      <div className="inner-box">
                        <div className="leftiii">
                          <img
                            src={Presale?.image}
                            alt="img"
                            className="img-fluid"
                            style={{
                              width: "35px",
                              height: "35px",
                              borderRadius: "120px",
                            }}
                          />
                          <div className="text">
                            <h6>{Presale?.name}</h6>
                            <p className="textpara">${Presale?.symbol}</p>
                          </div>
                        </div>
                        <div className="right">
                          <h6></h6>
                          <input
                            onChange={inputField1Handler1}
                            value={inputFeild1}
                            disabled
                            onWheel={(e) => e.target.blur()}
                            type="number"
                            placeholder="0.00"
                          />
                          {/* <p>0.00</p> */}
                        </div>
                      </div>
                    </div>
                    <div className="bottom-text">
                      <div className="inner-text-bold">
                        <h6 style={{ textAlign: "start" }}>You Receive:</h6>
                        <h6 style={{ fontFamily: "f37" }}>
                          {hasPremiumStakingPerks ? (
                            <>
                              {inputFeild1 && inputFeild
                                ? formatDisplayTokenAmount(ethValueCalcualte)
                                : "0"}
                            </>
                          ) : (
                            <>
                              {inputFeild1 && inputFeild
                                ? formatDisplayTokenAmount(inputFeild1)
                                : "0"}
                            </>
                          )}{" "}
                          ${Presale?.symbol}
                        </h6>
                      </div>
                      <div
                        className="inner-text-bold mt-3 w-100"
                        style={{ flexDirection: "column" }}
                      >
                        {checkBoxx && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="w-100 mb-3"
                          >
                            <h6
                              style={{ color: "#329879", textAlign: "start" }}
                            >
                              Gems Protect
                            </h6>
                            <h6>
                              <>
                                {inputFeild1 && inputFeild ? (
                                  <>
                                    {formatDisplayPaymentAmount(
                                      effectivePayCrypto * insurancePer,
                                    )}
                                  </>
                                ) : (
                                  "0.00"
                                )}
                              </>{" "}
                              {mainTag}
                              <span
                                style={{
                                  fontSize: "18px",
                                  color: "#77868B",
                                  marginLeft: "5px",
                                }}
                              >
                                ($
                                {inputFeild1 && inputFeild
                                  ? formatDisplayUsd(
                                    effectiveAmountInUsdt * insurancePer,
                                    2,
                                  )
                                  : "0"}
                                )
                              </span>
                            </h6>
                          </div>
                        )}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                          className="w-100"
                        >
                          <h6 style={{ color: "#329879" }}>You Pay:</h6>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-end",
                              flexDirection: "column",
                            }}
                          >
                            <h6>
                              <span
                                style={{
                                  fontFamily: "f37",
                                  color: "#329879",
                                }}
                              >
                                {inputFeild1 && inputFeild ? (
                                  <>
                                    {checkBoxx
                                      ? formatDisplayPaymentAmount(
                                        effectivePayCrypto +
                                        effectivePayCrypto * insurancePer,
                                      )
                                      : formatDisplayPaymentAmount(
                                        effectivePayCrypto,
                                      )}
                                  </>
                                ) : (
                                  "0.00"
                                )}
                              </span>{" "}
                              <span
                                style={{
                                  fontFamily: "f37",
                                  color: "#329879",
                                }}
                              >
                                {" "}
                                {mainTag}
                              </span>{" "}
                              <span
                                style={{
                                  fontFamily: "hregular",
                                  color: "#77868B",
                                }}
                              >
                                ($
                                {inputFeild1 && inputFeild ? (
                                  <>
                                    {checkBoxx
                                      ? formatDisplayUsd(
                                        effectiveAmountInUsdt +
                                        effectiveAmountInUsdt * insurancePer,
                                        2,
                                      )
                                      : formatDisplayUsd(
                                        effectiveAmountInUsdt,
                                        2,
                                      )}
                                  </>
                                ) : (
                                  0.0
                                )}
                                )
                              </span>
                            </h6>
                            {/* <h6 style={{ color: "#329879", fontSize: "16px", marginTop: "4px" }}>20% discount applied</h6> */}
                            <p className="networkmain">
                              Network:
                              <span> Ethereum Mainnet</span>
                            </p>
                          </div>
                        </div>
                        {stablecoinMinAdjustment ? (
                          <div className="amountadjusted-box">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#EFBB22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M12 16V12" stroke="#EFBB22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M12 8H12.01" stroke="#EFBB22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className="right-content">
                              <h6>
                                Amount adjusted to meet the $
                                {fmtUsd(regularMinOrderUsd)} minimum
                              </h6>
                              <p>
                                Due to the current USDT/USDC exchange rate, your
                                final payment amount was adjusted so the
                                purchase value equals{" "}
                                <span>${fmtUsd(regularMinOrderUsd)}</span>.
                              </p>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      {/* <div className="inner-text-bold">
                          <h6>Unlocks On:</h6>
                          <h6>
                            Q1,2024
                          </h6>
                        </div> */}

                      {/* <div className="inner-text">
                          <p>Unlock Date:</p>
                          <h6>{date}</h6>
                          <h6>Q1,2024</h6>
                        </div> */}
                    </div>
                    <div className="custom-checkboxes">
                      <div className="checkboxmainnnnnn">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            checked={checkDisclaimer}
                            onChange={handleDisclaimerCheckbox}
                          ></input>
                          <span class="checkmark"></span>
                        </label>
                        <p className="checkboxpara">
                          I have read and understood the disclaimer and hereby
                          agree to its{" "}
                          <a
                            onClick={handleShowTermsServices}
                            style={{ cursor: "pointer" }}
                          >
                            terms and conditions
                          </a>
                          .<span>*</span>
                        </p>
                      </div>
                      {attemptedDisclaimer && !readDisclaimer && (
                        <p className="error-text">
                          To continue, please open and review the Terms &
                          Conditions.
                        </p>
                      )}
                      <div className="checkboxmainnnnnn">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            checked={checkPurchaseDisclaimer}
                            onChange={(e) =>
                              setCheckPurchaseDisclaimer(e.target.checked)
                            }
                          />
                          <span class="checkmark"></span>
                        </label>
                        <p className="checkboxpara">
                          <span style={{ fontFamily: "hbold", color: "#212121" }}>I have read and understood the Disclaimer and
                            acknowledge the risks before proceeding with the
                            purchase:</span> Certain statements made by the project may
                          relate to future functionality, roadmap objectives,
                          regulated services, or integrations that remain
                          subject to future implementation, licensing, or
                          regulatory approvals. Listing on Gems Launchpad does
                          not constitute verification or confirmation of the
                          project&apos;s regulatory status, operational
                          readiness, or service availability in any
                          jurisdiction. Participants should conduct their own
                          independent assessment.
                          <span>*</span>
                        </p>
                      </div>
                      <div className="checkboxmainnnnnn">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            checked={checkCitizenship}
                            onChange={(e) =>
                              setCheckCitizenship(e.target.checked)
                            }
                          />
                          <span class="checkmark"></span>
                        </label>
                        <p className="checkboxpara">
                          I hereby confirm that I am not a citizen of the
                          United States of America or Israel<span>*</span>
                        </p>
                      </div>
                      <div className="checkboxmainnnnnn">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            checked={checkMerketing}
                            onChange={(e) =>
                              setCheckMerketing(e.target.checked)
                            }
                          />
                          <span class="checkmark"></span>
                        </label>
                        <p className="checkboxpara">
                          I acknowledge that I may receive marketing
                          communications.
                        </p>
                      </div>
                    </div>
                    <p className="approvepara">
                      You will need to approve the transaction in your wallet.
                    </p>
                    {account ? (
                      <>
                        {!timeshow &&
                          currentTime >
                          new Date(parseInt(currentRount?.startTime)) &&
                          currentTime <
                          new Date(parseInt(currentRount?.endTime)) ? (
                          <>
                            {
                              <>
                                {/* {psMaxxCap>=psmyTotlaPurchasess? */}
                                <>
                                  {mainTag === "ETH" ? (
                                    <>
                                      {inputFeild == "" ||
                                        !canBuyWithRoundLimits ||
                                        inputFeild == null ||
                                        inputFeild <= 0 ? (
                                        <button className=" btn-buy">
                                          Buy ${Presale?.symbol}{" "}
                                        </button>
                                      ) : (
                                        <button
                                          className="newClasss"
                                          onClick={handlerPop}
                                        >
                                          Buy ${Presale?.symbol}{" "}
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {mainTag == "USDT" ? (
                                        <>
                                          {inputFeild == "" ||
                                            inputFeild == null ||
                                            !canBuyWithRoundLimits ||
                                            inputFeild <= 0 ? (
                                            <button className=" btn-buy">
                                              Buy ${Presale?.symbol}
                                            </button>
                                          ) : (
                                            <button
                                              className="newClasss"
                                              onClick={handlerPop}
                                            >
                                              Buy ${Presale?.symbol}{" "}
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {mainTag == "USDC" ? (
                                            <>
                                              {inputFeild == "" ||
                                                inputFeild == null ||
                                                !canBuyWithRoundLimits ||
                                                inputFeild <= 0 ? (
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}
                                                </button>
                                              ) : (
                                                <button
                                                  className="newClasss"
                                                  onClick={handlerPop}
                                                >
                                                  Buy $
                                                  {Presale?.symbol}{" "}
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {mainTag == "WBTC" ? (
                                                <>
                                                  {inputFeild == "" ||
                                                    inputFeild == null ||
                                                    !canBuyWithRoundLimits ||
                                                    inputFeild <= 0 ? (
                                                    <button className=" btn-buy">
                                                      Buy $
                                                      {Presale?.symbol}{" "}
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="newClasss"
                                                      onClick={handlerPop}
                                                    >
                                                      Buy $
                                                      {Presale?.symbol}{" "}
                                                    </button>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {mainTag == "LINK" ? (
                                                    <>
                                                      {inputFeild == "" ||
                                                        inputFeild == null ||
                                                        !canBuyWithRoundLimits ||
                                                        inputFeild <= 0 ? (
                                                        <button className=" btn-buy">
                                                          Buy $
                                                          {
                                                            Presale?.symbol
                                                          }{" "}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={
                                                            handlerPop
                                                          }
                                                        >
                                                          Buy $
                                                          {
                                                            Presale?.symbol
                                                          }{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {mainTag == "PEPE" ? (
                                                        <>
                                                          {inputFeild ==
                                                            "" ||
                                                            inputFeild ==
                                                            null ||
                                                            !canBuyWithRoundLimits ||
                                                            inputFeild <=
                                                            0 ? (
                                                            <button className=" btn-buy">
                                                              Buy $
                                                              {
                                                                Presale?.symbol
                                                              }{" "}
                                                            </button>
                                                          ) : (
                                                            <button
                                                              className="newClasss"
                                                              onClick={
                                                                handlerPop
                                                              }
                                                            >
                                                              Buy $
                                                              {
                                                                Presale?.symbol
                                                              }{" "}
                                                            </button>
                                                          )}
                                                        </>
                                                      ) : (
                                                        <>
                                                          {mainTag ==
                                                            "UNI" ? (
                                                            <>
                                                              {inputFeild ==
                                                                "" ||
                                                                inputFeild ==
                                                                null ||
                                                                !canBuyWithRoundLimits ||
                                                                inputFeild <=
                                                                0 ? (
                                                                <button className=" btn-buy">
                                                                  Buy $
                                                                  {
                                                                    Presale?.symbol
                                                                  }{" "}
                                                                </button>
                                                              ) : (
                                                                <button
                                                                  className="newClasss"
                                                                  onClick={
                                                                    handlerPop
                                                                  }
                                                                >
                                                                  Buy $
                                                                  {
                                                                    Presale?.symbol
                                                                  }{" "}
                                                                </button>
                                                              )}
                                                            </>
                                                          ) : (
                                                            <>
                                                              {mainTag ==
                                                                "DOP" ? (
                                                                <>
                                                                  {inputFeild ==
                                                                    "" ||
                                                                    inputFeild ==
                                                                    null ||
                                                                    !canBuyWithRoundLimits ||
                                                                    inputFeild <=
                                                                    0 ? (
                                                                    <button className=" btn-buy">
                                                                      Buy $
                                                                      {
                                                                        Presale?.symbol
                                                                      }{" "}
                                                                    </button>
                                                                  ) : (
                                                                    <button
                                                                      className="newClasss"
                                                                      onClick={
                                                                        handlerPop
                                                                      }
                                                                    >
                                                                      Buy $
                                                                      {
                                                                        Presale?.symbol
                                                                      }{" "}
                                                                    </button>
                                                                  )}
                                                                </>
                                                              ) : (
                                                                <>
                                                                  {mainTag ==
                                                                    "TOMI" ? (
                                                                    <>
                                                                      {inputFeild ==
                                                                        "" ||
                                                                        inputFeild ==
                                                                        null ||
                                                                        !canBuyWithRoundLimits ||
                                                                        inputFeild <=
                                                                        0 ? (
                                                                        <button className=" btn-buy">
                                                                          Buy
                                                                          $
                                                                          {
                                                                            Presale?.symbol
                                                                          }
                                                                        </button>
                                                                      ) : (
                                                                        <button
                                                                          className="newClasss"
                                                                          onClick={
                                                                            handlerPop
                                                                          }
                                                                        >
                                                                          Buy
                                                                          $
                                                                          {
                                                                            Presale?.symbol
                                                                          }{" "}
                                                                        </button>
                                                                      )}
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      {inputFeild ==
                                                                        "" ||
                                                                        inputFeild ==
                                                                        null ||
                                                                        !canBuyWithRoundLimits ||
                                                                        inputFeild <=
                                                                        0 ? (
                                                                        <button className=" btn-buy">
                                                                          Buy
                                                                          $
                                                                          {
                                                                            Presale?.symbol
                                                                          }
                                                                        </button>
                                                                      ) : (
                                                                        <button
                                                                          className="newClasss"
                                                                          onClick={
                                                                            handlerPop
                                                                          }
                                                                        >
                                                                          Buy
                                                                          $
                                                                          {
                                                                            Presale?.symbol
                                                                          }{" "}
                                                                        </button>
                                                                      )}
                                                                    </>
                                                                  )}
                                                                </>
                                                              )}
                                                            </>
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              </>
                              // <button className=" newClasss" onClick={handlerPop}>Buy GEMS </button>
                            }
                          </>
                        ) : (
                          <button className="btn-buy">
                            Buy ${Presale?.symbol}
                          </button>
                        )}
                      </>
                    ) : (
                      <button
                        className="btn-buy"
                        onClick={() => setShow(true)}
                      >
                        Buy ${Presale?.symbol}
                      </button>
                    )}
                  </div>
                </Tab>

                {/* <Tab eventKey="profile" title="Buy NFTs">
                    <DopNft
                      email={email}
                      psMaxxCap={psMaxxCap}
                      psmyTotlaPurchasess={psmyTotlaPurchasess}
                      timeshow={timeshow}
                      balaceOfWbtc={balaceOfWbtc}
                      balaceOfUsdc={balaceOfUsdc}
                      getAllowanceWbtc={getAllowanceWbtc}
                      getAllowanceUsdc={getAllowanceUsdc}
                      setShow={setShow}
                      price={price}
                      wbtcCurrentPrice={wbtcCurrentPrice}
                      ethPricevalue={ethPricevalue}
                      code={code}
                      setLoarder={setLoarder}
                      saleCurrentStaus={saleCurrentStaus}
                      currentRoundd={currentRoundd}
                      blanceOfEth={blanceOfEth}
                      balanceeUsdt={balanceeUsdt}
                      pepePrice={pepePrice}
                      tomiAllowance={tomiAllowance}
                      allowanceTpl={allowanceTpl}
                      balaceOfTmi={balaceOfTmi}
                      alowence={alowence}
                      sallowance={sallowance}
                      discoundedPriceee={discoundedPriceee}
                      tab={tab}
                      setMyPsTotlaPurchasess={setMyPsTotlaPurchasess}
                      psTotlaPurchasess={psTotlaPurchasess}
                      stakeIndex={stakeIndex}
                      stakedAmount={stakedAmount}
                      discountedPriceee={discountedPriceee}
                      round={round}
                      linkPricevalue={linkPricevalue}
                      uniPricevalue={uniPricevalue}
                      pepeAllowance={pepeAllowance}
                      linkAllowance={linkAllowance}
                      uniAllowance={uniAllowance}
                      balaceOfLinkk={balaceOfLinkk}
                      balaceOfPepee={balaceOfPepee}
                      balaceOfUnii={balaceOfUnii}
                      dopAllowance={dopAllowance}
                      balaceOfDoppp={balaceOfDoppp}
                      dopPricevalue={dopPricevalue}
                      insurancePer={insurancePer}
                      checkBoxx={checkBoxx}
                      tomiPrice={tomiPrice}
                      gemsAllowance={gemsAllowance}
                      gemsBalance={gemsBalance}
                      gemsPrice={gemsPrice}
                      allowedTokens={allowedTokens}
                      getGasFeeInUSD={getGasFeeInUSD}
                      buyingNetworkFee={buyingNetworkFee}
                      setbuyingNetworkFee={setbuyingNetworkFee}
                      stakingData={hasPremiumStakingPerks}
                    />
                  </Tab> */}
              </Tabs>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <Modal
        className="connectwallet-modal connectwallet-newmodal"
        show={!isVerificationDone}
        // onHide={handleCloseVerification}
        centered
        enforceFocus={false}
      >
        <Modal.Header>
          <div className="multi-steps">
            <div className="common-step">
              {account ? (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <rect width="30" height="30" rx="15" fill="#329879" />
                    <path
                      d="M21.1448 13.0837L21.1448 7.93555L13.3011 15.7597L8.625 12.4608L8.625 17.2336L13.3011 20.7571L21.1448 13.0837Z"
                      fill="#ECF5F9"
                    />
                  </svg>
                </>
              ) : (
                <span className={account ? "" : "active"}>1</span>
              )}
              <h6>Connect Wallet</h6>
            </div>
            <span className="middle-line"></span>
            <div className={`common-step `}>
              <span className={account ? "active" : ""}>2</span>
              <h6>Confirm Email</h6>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {!account ? (
            <div className="connect-wallet-parent">
              <div className="upper-heading">
                <h6>Connect Your Wallet</h6>
                <p>
                  Choose your preferred wallet to continue with the purchase
                </p>
              </div>
              <div className="wallets-parent">
                <button onClick={connectMetaMask1} className="d-noneformobile">
                  <img
                    src="\assets\metamask.svg"
                    alt="img"
                    className="img-fluid"
                  />{" "}
                  Metamask
                </button>
                <button onClick={trustWallet}>
                  <img
                    src="\assets\walletconnect.svg"
                    alt="img"
                    className="img-fluid"
                  />{" "}
                  WalletConnect
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="ifwalletconnected">
                <div className="left-text">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1737_20899)">
                      <circle
                        cx="6.99963"
                        cy="6.99963"
                        r="6.99963"
                        fill="#329879"
                      />
                      <path
                        d="M5.71603 10.5958L2.63379 7.51373L3.66111 6.48641L5.71603 8.54119L10.3391 3.91797L11.3664 4.94529L5.71603 10.5958Z"
                        fill="#E2E9EC"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1737_20899">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p>Wallet Connected:</p>
                </div>
                <h6>
                  {/* <img src="\assets\metamask-mini-icon.svg" alt="img" className="img-fluid" /> */}
                  {account.slice(0, 6)}...{account.slice(-4)}
                </h6>
              </div>
              {isEmailVerified && (
                <div className="continue-with-verifiedemail">
                  <div className="upper-heading">
                    <h6>Continue with verified email?</h6>
                    <p>
                      Your wallet is associated with a verified email. You'll
                      receive a confirmation there once your purchase is
                      complete
                    </p>
                  </div>
                  <div className="verifiedemail-box">
                    <div className="left-content">
                      <p>Verified Email</p>
                      <h6>{email}</h6>
                    </div>
                    <h6 className="verifiedlabel">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1737_20947)">
                          <circle
                            cx="6.99963"
                            cy="6.99963"
                            r="6.99963"
                            fill="#329879"
                          />
                          <path
                            d="M5.71603 10.5958L2.63379 7.51373L3.66111 6.48641L5.71603 8.54119L10.3391 3.91797L11.3664 4.94529L5.71603 10.5958Z"
                            fill="#E2E9EC"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1737_20947">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Email Verified
                    </h6>
                  </div>
                </div>
              )}
              {!isEmailVerified && (
                <>
                  <div className="ifanother-email">
                    <div className="upper-heading">
                      <h6>Enter Your Email</h6>
                      <p>
                        Provide your email address to receive purchase
                        confirmations.
                      </p>
                    </div>
                    <div className="option-field">
                      <label>Email Address</label>
                      <input
                        type="email"
                        value={email}
                        placeholder="your@email.com"
                        onChange={handleInputMail}
                        className={!isValidMail ? "error" : ""}
                      />
                      {!isValidMail && (
                        <p className="error-text">Invalid Email</p>
                      )}
                      {isMailVerificationChecked && (
                        <a
                          href="#"
                          className={`btn-send ${!isValidMail || isResendDisabled ? "disabled" : ""
                            }`}
                          onClick={handleSendCode}
                          style={{
                            pointerEvents: isResendDisabled ? "none" : "auto",
                            opacity: !isValidMail || isResendDisabled ? 0.5 : 1,
                          }}
                        >
                          {isResendDisabled
                            ? `Resend in ${resendTimer}s`
                            : codeSentOnce
                              ? "Resend "
                              : "Send Code"}
                        </a>
                      )}
                    </div>
                    {otpRequired && codeSentOnce && (
                      <div className="option-field">
                        <label>Verification Code</label>
                        <input
                          type="text"
                          value={otp}
                          onChange={(e) => {
                            setOtp(e.target.value);
                            setIsCodeValid(true);
                          }}
                          className={isCodeValid ? "" : "error"}
                          placeholder="Enter 6-digit code here"
                        />
                        {!isCodeValid && (
                          <p className="error-text">
                            Invalid email verification code
                          </p>
                        )}
                      </div>
                    )}
                    {isMailVerificationChecked &&
                      otpRequired &&
                      !codeSentOnce && (
                        <div className="email-not-veirified-error">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_1790_1877)">
                              <circle
                                cx="8.99953"
                                cy="8.99953"
                                r="8.99953"
                                fill="#FC4F52"
                              />
                              <path
                                d="M11.3328 13.091L8.89564 9.88506L6.63258 13.091H4.90918L8.00783 8.69953L5.11808 4.90918H6.8763L9.06972 7.79786L11.1413 4.90918H12.8473L10.7235 7.81456H9.08713L13.091 13.091H11.3328Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1790_1877">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <p>
                            This email is not verified. Please verify it to
                            continue.
                          </p>
                        </div>
                      )}
                  </div>
                  <div className="bottom-btns">
                    {codeSentOnce ? (
                      <button
                        className="btn-common"
                        disabled={!isCodeValid || otp.length <= 0}
                        style={{
                          opacity:
                            !isCodeValid || otp.length <= 0 ? "0.5" : "1",
                        }}
                        onClick={handlVerifyCode}
                      >
                        Verify
                      </button>
                    ) : (
                      <button
                        className="btn-common"
                        disabled={otpRequired}
                        style={{ opacity: otpRequired ? "0.5" : "1" }}
                        onClick={handlCheckEmailVerification}
                      >
                        Continue
                      </button>
                    )}
                  </div>
                </>
              )}
              {isEmailVerified && (
                <div className="bottom-btns">
                  <button
                    className="btn-common"
                    onClick={handleContinueWithVerifiedMail}
                  >
                    Continue with this Email
                  </button>
                  <button
                    className="btn-another"
                    onClick={handleContinueWithAnotherEmail}
                  >
                    Use a different email
                  </button>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal buy-modal trx-modal"
        show={show1}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>${Presale?.symbol} Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-modal">
            <h4>${Presale?.symbol} Purchase Completed !</h4>
            <p>Here’s a summary of your transaction</p>
            {showBulkPurchaseSummary ? (
              <>
                <div className="token-purchased-area">
                  <div className="single-value">
                    <h5>
                      Tokens Purchased
                      {/* <div className="tooltipmain">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M6.99984 12.8332C10.2215 12.8332 12.8332 10.2215 12.8332 6.99984C12.8332 3.77818 10.2215 1.1665 6.99984 1.1665C3.77818 1.1665 1.1665 3.77818 1.1665 6.99984C1.1665 10.2215 3.77818 12.8332 6.99984 12.8332Z"
                            stroke="#77868B"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7 4.6665V6.99984"
                            stroke="#77868B"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7 9.3335H7.00583"
                            stroke="#77868B"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div className="innertooltip">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="6"
                            viewBox="0 0 16 6"
                            fill="none"
                            className="arrowsvg"
                          >
                            <path
                              d="M5.36598 0.989823C6.87409 -0.329768 9.12591 -0.329767 10.634 0.989824L16 5.68506H0L5.36598 0.989823Z"
                              fill="#C0CBCF"
                            />
                          </svg>
                          Added to your wallet balance shortly after confirmation
                        </div>
                      </div> */}
                    </h5>
                    <h6>
                      {hasPremiumStakingPerks ? (
                        <>
                          {inputFeild1 && inputFeild
                            ? formatDisplayTokenAmount(ethValueCalcualte)
                            : "0"}
                        </>
                      ) : (
                        <>
                          {inputFeild1 && inputFeild
                            ? formatDisplayTokenAmount(inputFeild1)
                            : "0"}
                        </>
                      )}{" "}
                      ${Presale?.symbol}
                    </h6>
                  </div>
                </div>
                <div className="token-purchased-area tokenpurchasedlast">
                  <div
                    className="single-value"
                    style={{
                      borderBottom: "1px solid transparent",
                      paddingBottom: "0",
                    }}
                  >
                    <h5>
                      Original Amount (
                      {inputFeild1 && inputFeild && bulkPurchaseSummary
                        ? `${formatDisplayPaymentAmount(
                          bulkPurchaseSummary.originalPayCrypto,
                        )} ${mainTag}`
                        : `0 ${mainTag}`}
                      )
                    </h5>
                    <h6>
                      <span style={{ color: "#77868B" }}>
                        $
                        {inputFeild1 &&
                          inputFeild &&
                          bulkPurchaseSummary
                          ? formatDisplayUsd(
                            bulkPurchaseSummary.originalUsd,
                            2,
                          )
                          : "0"}
                      </span>
                    </h6>
                  </div>
                  <div
                    className="single-value"
                    style={{ borderBottom: "1px solid #C0CBCF" }}
                  >
                    <h5>Discount Amount</h5>
                    <h6 style={{ color: "#329879" }}>
                      -$
                      {inputFeild1 &&
                        inputFeild &&
                        bulkPurchaseSummary
                        ? formatDisplayUsd(
                          bulkPurchaseSummary.discountUsd,
                          2,
                        )
                        : "0"}
                    </h6>
                  </div>
                  <div className="single-value">
                    <h5>Token Purchase Amount</h5>
                    <h6>
                      {inputFeild1 && inputFeild
                        ? formatDisplayPaymentAmount(inputFeild)
                        : "0"}{" "}
                      {mainTag}{" "}
                      <span>
                        ($
                        {inputFeild1 && inputFeild
                          ? formatDisplayUsd(amountInUsdt, 2)
                          : "0"}
                        )
                      </span>
                    </h6>
                  </div>
                  {checkBoxx && (
                    <div className="single-value">
                      <h5>Gems Protect</h5>
                      <h6>
                        <>
                          {inputFeild1 && inputFeild ? (
                            <>
                              {formatDisplayPaymentAmount(
                                inputFeild * insurancePer,
                              )}
                            </>
                          ) : (
                            "0.00"
                          )}
                        </>{" "}
                        {mainTag}
                        <span>
                          ($
                          {inputFeild1 && inputFeild
                            ? formatDisplayUsd(
                              amountInUsdt * insurancePer,
                              2,
                            )
                            : "0"}
                          )
                        </span>
                      </h6>
                    </div>
                  )}
                  <div
                    className={
                      checkBoxx ? "single-value newborderr" : "single-value"
                    }
                    style={{
                      borderBottom: !checkBoxx ? "none" : "1px solid #C0CBCF",
                    }}
                  >
                    <h5>Total Spent (incl. network fees) </h5>
                    <h6 style={{ color: "#329879" }}>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {checkBoxx
                            ? formatDisplayPaymentAmount(
                              parseFloat(inputFeild) +
                              inputFeild * insurancePer,
                            )
                            : formatDisplayPaymentAmount(inputFeild)}
                        </>
                      ) : (
                        "0.00"
                      )}{" "}
                      {mainTag}{" "}
                      <span style={{ color: "#77868B" }}>
                        ($
                        {inputFeild1 && inputFeild ? (
                          <>
                            {checkBoxx
                              ? formatDisplayUsd(
                                amountInUsdt +
                                amountInUsdt * insurancePer +
                                buyingNetworkFee,
                                2,
                              )
                              : formatDisplayUsd(
                                amountInUsdt + buyingNetworkFee,
                                2,
                              )}
                          </>
                        ) : (
                          0.0
                        )}
                        )
                      </span>
                    </h6>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="token-purchased-area">
                  <div className="single-value">
                    <h5>
                      Tokens Received
                      {/* <div className="tooltipmain">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M6.99984 12.8332C10.2215 12.8332 12.8332 10.2215 12.8332 6.99984C12.8332 3.77818 10.2215 1.1665 6.99984 1.1665C3.77818 1.1665 1.1665 3.77818 1.1665 6.99984C1.1665 10.2215 3.77818 12.8332 6.99984 12.8332Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 4.6665V6.99984"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 9.3335H7.00583"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div className="innertooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="6"
                        viewBox="0 0 16 6"
                        fill="none"
                        className="arrowsvg"
                      >
                        <path
                          d="M5.36598 0.989823C6.87409 -0.329768 9.12591 -0.329767 10.634 0.989824L16 5.68506H0L5.36598 0.989823Z"
                          fill="#C0CBCF"
                        />
                      </svg>
                      Added to your wallet balance shortly after confirmation
                    </div>
                  </div> */}
                    </h5>
                    <h6>
                      {hasPremiumStakingPerks ? (
                        <>
                          {inputFeild1 && inputFeild
                            ? formatDisplayTokenAmount(ethValueCalcualte)
                            : "0"}
                        </>
                      ) : (
                        <>
                          {inputFeild1 && inputFeild
                            ? formatDisplayTokenAmount(inputFeild1)
                            : "0"}
                        </>
                      )}{" "}
                      ${Presale?.symbol}
                    </h6>
                  </div>
                </div>
                <div className="token-purchased-area tokenpurchasedlast">
                  {/* {checkBoxx && ( */}
                  <div className="single-value">
                    <h5>Token Purchase Amount</h5>
                    <h6>
                      {inputFeild1 && inputFeild
                        ? formatDisplayPaymentAmount(inputFeild)
                        : "0"}{" "}
                      {mainTag}{" "}
                      <span>
                        ($
                        {inputFeild1 && inputFeild
                          ? formatDisplayUsd(amountInUsdt, 2)
                          : "0"}
                        )
                      </span>
                    </h6>
                  </div>
                  {/* )} */}
                  {checkBoxx && (
                    <div className="single-value">
                      <h5>Gems Protect</h5>
                      <h6>
                        <>
                          {inputFeild1 && inputFeild ? (
                            <>
                              {formatDisplayPaymentAmount(
                                inputFeild * insurancePer,
                              )}
                            </>
                          ) : (
                            "0.00"
                          )}
                        </>{" "}
                        {mainTag}
                        <span>
                          ($
                          {inputFeild1 && inputFeild
                            ? formatDisplayUsd(amountInUsdt * insurancePer, 2)
                            : "0"}
                          )
                        </span>
                      </h6>
                    </div>
                  )}
                  <div
                    className={
                      checkBoxx ? "single-value newborderr" : "single-value"
                    }
                    style={{
                      borderBottom: !checkBoxx ? "none" : "1px solid #C0CBCF",
                    }}
                  >
                    <h5>Total Spent (incl. network fees) </h5>
                    <h6 style={{ color: "#329879" }}>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {checkBoxx
                            ? formatDisplayPaymentAmount(
                              parseFloat(inputFeild) + inputFeild * insurancePer,
                            )
                            : formatDisplayPaymentAmount(inputFeild)}
                        </>
                      ) : (
                        "0.00"
                      )}{" "}
                      {mainTag}{" "}
                      <span style={{ color: "#77868B" }}>
                        ($
                        {inputFeild1 && inputFeild ? (
                          <>
                            {checkBoxx
                              ? formatDisplayUsd(
                                amountInUsdt +
                                amountInUsdt * insurancePer +
                                buyingNetworkFee,
                                2,
                              )
                              : formatDisplayUsd(
                                amountInUsdt + buyingNetworkFee,
                                2,
                              )}
                          </>
                        ) : (
                          0.0
                        )}
                        )
                      </span>
                    </h6>
                  </div>
                </div>
              </>
            )}

            {selectedRoundKind === "special" && <div className="access-unlock-box">
              <div className="main-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M16.667 4.16797H3.33366C2.41318 4.16797 1.66699 4.91416 1.66699 5.83464V14.168C1.66699 15.0884 2.41318 15.8346 3.33366 15.8346H16.667C17.5875 15.8346 18.3337 15.0884 18.3337 14.168V5.83464C18.3337 4.91416 17.5875 4.16797 16.667 4.16797Z" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M1.66699 8.33203H18.3337" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div className="right-content">
                <div className="single-box">
                  <div className="inner-left">
                    <h6 className="green-text">Credit Refund Access Unlocked</h6>
                    <p>You can now use your existing Credit Refund credits for KAI.</p>
                  </div>
                  <div className="price-tag">
                    <p className="green-text">{fmtCredits(specialKaiCredits)} credits</p>
                  </div>
                </div>
                <div className="single-box">
                  <div className="inner-left">
                    <h6>Your Available Credit Refund Balance</h6>
                  </div>
                  <div className="price-tag">
                    <p className="green-text">
                      {fmtCredits(remainingCreditUsd)} credits
                    </p>
                  </div>
                </div>
                {/* <div className="single-box">
                  <div className="inner-left">
                    <h6 className="green-text">Credits Available to Use for KAI</h6>
                  </div>
                  <div className="price-tag">
                    <p className="green-text">
                      {fmtCredits(specialKaiCredits)} credits
                    </p>
                  </div>
                </div> */}
              </div>
            </div>}
            {selectedRoundKind === "special" && <div className="warning-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M13.9997 25.6654C20.443 25.6654 25.6663 20.442 25.6663 13.9987C25.6663 7.55538 20.443 2.33203 13.9997 2.33203C7.55635 2.33203 2.33301 7.55538 2.33301 13.9987C2.33301 20.442 7.55635 25.6654 13.9997 25.6654Z" stroke="#329879" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14 9.33203V13.9987" stroke="#329879" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14 18.668H14.0091" stroke="#329879" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <div className="inner-content">
                <h6>This round does not issue new credits.</h6>
                <p>It only unlocks the ability to use your <span>existing available credits</span> for KAI.</p>
              </div>
            </div>}

            <button
              className="btn-common"
              onClick={() => {
                handleClose();
                history.push("/claim?buy=true");
              }}
              style={{ marginTop: "20px" }}
            >
              OK
            </button>
          </div>


        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal premiumstake-modal newmodalbackdrop"
        show={PREMIUM_STAKING_FLOW_ENABLED && show0}
        onHide={handleClos0}
        centered
        backdrop={false}
        keyboard={false}
      >
        <Modal.Body>
          <div className="stakingmodal">
            <div className="inner-content">
              <img
                src="\assets\premium\modalbg.png"
                alt="img"
                className="img-fluid modalbg-stake"
              />
              <img
                src="\assets\premium\goldenuser.svg"
                alt="img"
                className="img-fluid"
              />
              <h5>
                Get Gems Premium and <br />
                Receive {round == 1 ? "20" : "7"}% Discount
              </h5>
            </div>
            <div className="d-flex justify-content-center mb-4">
              {/* <p className="text-danger ">{walletError}</p> */}
            </div>
            <div className="stakingbtns">
              <button
                onClick={() => {
                  handleClos0();
                }}
                className="cancelbtn"
              >
                Continue
              </button>
              <button
                onClick={() => {
                  history.push("/discount");
                }}
                className="confirmbtn"
              >
                Get Gems Premium
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <TermsOfServiceModal
        show={showtermsservices}
        onHide={handleCloseTermsServices}
      />
    </>
  );
};

export default Banner;